import BUILDING_INSPECTION from './buildingInspection';
import ENERGY_LABEL_LEADS from './energyLabelLeads';

const NORWEGIAN = {
  type: 'nb-NO',
  languageNames: {
    en: 'Engelsk',
    no: 'Norsk',
    nb: 'Norsk',
    de: 'Tysk',
    fr: 'Fransk',
    sv: 'Svensk',
    se: 'Svensk',
    da: 'Dansk',
    it: 'Italiensk',
    fi: 'Finsk',
  },
  global: {
    noDataAvailable: 'Ingen data tilgjengelig',
    move: 'Flytt',
    rotate: 'Roter',
    model: 'Modell',
    data: 'Data',
    all: 'Alle',
    controls: 'Styring',
    lastUpdated: 'Sist oppdatert',
    noData: 'Ingen data',
    custom: 'Egendefinert',
    name: 'Navn',
    setpoints: 'Setpunkt',
    email: 'E-post',
    date: 'Dato',
    timestamp: 'Tidspunkt',
    address: 'Adresse',
    street: 'Gate',
    postcode: 'Postnummer',
    city: 'By',
    country: 'Land',
    timezone: 'Tidssone',
    language: 'Språk',
    new: 'Ny',
    from: 'Fra',
    until: 'Til',
    selectStartDate: 'Velg startdato',
    selectEndDate: 'velg sluttdato',
    copied: 'Kopiert',
    average: 'Snitt',
    min: 'Min',
    max: 'Maks',
    last: 'Siste',
    type: 'Type',
    role: 'Rolle',
    category: 'Kategori',
    description: 'Beskrivelse',
    status: 'Status',
    public: 'Offentlig',
    active: 'Aktiv',
    inactive: 'Inaktiv',
    hidden: 'Skjult',
    visible: 'Synlig',
    show: 'Vis',
    hide: 'Skjul',
    enabled: 'Aktivert',
    disabled: 'Deaktivert',
    actionRequired: 'Handling kreves',
    success: 'Suksess',
    none: 'Ingen',
    error: 'Feil',
    basicInfo: 'Enhetsinformasjon',
    information: 'Informasjon',
    display: 'Visning',
    save: 'Lagre',
    saving: 'Lagrer…',
    saveSuccess: 'Lagret',
    saveError: 'Kunne ikke lagre',
    search: 'Søk',
    close: 'Lukk',
    confirm: 'Bekreft',
    yes: 'Ja',
    no: 'Nei',
    cancel: 'Avbryt',
    update: 'Oppdater',
    updating: 'Oppdaterer...',
    undo: 'Angre',
    done: 'Ferdig',
    delete: 'Slett',
    discard: 'Forkast',
    rename: 'Gi nytt navn',
    editName: 'Rediger navn',
    download: 'Last ned',
    open: 'Åpne',
    password: 'Passord',
    login: 'Logg inn',
    loginWithAzure: 'Logg inn med Azure',
    invalidCredentials: 'Ugyldige legitimasjonsopplysninger',
    loginTooManyAttempts:
      'For mange innloggingsforsøk, prøv igjen om noen minutter',
    loginInactiveUser: 'Denne brukerkontoen er ikke lenger aktiv',
    loginUnavailable: 'Kunne ikke logge inn akkurat nå, prøv igjen senere',
    welcome: 'Velkommen til Sastech',
    loginSubtitle: 'Logg inn for å få tilgang til dashbordet',
    or: 'eller',
    key: 'Nøkkel',
    back: 'Tilbake',
    apply: 'Bruk',
    inDevelopment: 'Under utvikling',
    notAuthorized: 'Ikke autorisert',
    add: 'Legg til',
    heating: 'Oppvarming',
    cooling: 'Kjøling',
    ventilation: 'Ventilasjon',
    climate: 'Inneklima',
    battery: 'Batteri',
    batteries: 'Batterier',
    capabilities: 'Funksjoner',
    moveTo: 'Flytt til',
    building: 'Bygning',
    buildings: 'Bygninger',
    floor: 'Etasje',
    floors: 'Etasjer',
    sensors: 'Sensorer',
    sensor: 'Sensor',
    controller: 'Kontroller',
    energySource: 'Energikilde',
    session: 'Økt',
    addDevice: 'Legg til enhet',
    device: 'Enhet',
    devices: 'Enheter',
    selectDevice: 'Velg en enhet',
    edit: 'Rediger',
    serialNumber: 'Serienummer',
    trash: 'Papirkurv',
    emptyTrash: 'Tøm papirkurven',
    actions: 'Handlinger',
    restore: 'Gjenopprett',
    selectCategory: 'Velg...',
    create: 'Opprett',
    monthChartText: [
      'Jan',
      'Feb',
      'Mar',
      'Apr',
      'Mai',
      'Jun',
      'Jul',
      'Aug',
      'Sep',
      'Okt',
      'Nov',
      'Des',
    ],
    weekdaysShort: ['Man', 'Tir', 'Ons', 'Tor', 'Fre', 'Lør', 'Søn'],
    weekdays: [
      'Søndag',
      'Mandag',
      'Tirsdag',
      'Onsdag',
      'Torsdag',
      'Fredag',
      'Lørdag',
    ],
    today: 'I dag',
    title: 'Tittel',
    to: 'til',
    remove: 'Fjern',
    inspect: 'Inspiser',
    compare: 'Sammenlign',
    export: 'Eksporter',
    total: 'Totalt',
    activate: 'Aktiver',
    color: 'Farge',
    text: 'Tekst',
    link: 'Lenke',
    frame: 'Ramme',
    info: 'Info',
    saveChanges: 'Lagre endringer',
    sidebarMenu: 'Sidemeny',
    icons: 'Ikoner',
    ok: 'OK',
    exit: 'Lukk',
    exportImage: 'Eksporter bilde',
    exportSelected: 'Eksporter valgte',
    directions: {
      top: 'Topp',
      bottom: 'Bunn',
      right: 'Høyre',
      left: 'Venstre',
      front: 'Front',
      back: 'Bak',
      isometric: 'Isometrisk',
    },
    switchVendor: 'Bytt leverandør',
    searchVendors: 'Søk leverandører...',
    noVendorsFound: 'Ingen leverandører funnet',
    onlyFjordkraft: 'Kun Fjordkraft',
  },
  chart: {
    zoomIn: 'Zoom inn',
    zoomOut: 'Zoom ut',
    rotate: 'Roter',
    fullscreen: 'Fullskjerm',
    rotateTip: 'Klikk og dra for å rotere diagram',
  },
  data: {
    loading: 'Laster...',
    loadingData: 'Laster data...',
    noResults: 'Ingen resultater funnet.',
    error: 'Feil',
    failedToLoadData: 'Kunne ikke laste data',
    noDataAvailable: 'Ingen data tilgjengelig',
  },
  general: {
    temperature: 'Temperatur',
    co2: 'CO₂',
    humidity: 'Fuktighet',
    zone: 'Sone',
    data: 'Data',
    edit: 'Rediger',
    analyze: 'Analyser',
    chartType: 'Diagramtype',
    toggleSeries: 'Veksle serier',
    resetFilters: 'Tilbakestill filtre',
    exportData: 'Eksporter data',
  },
  chat: {
    title: 'Sastech Chat',
    placeholder: 'Skriv inn meldingen din her…',
    send: 'Send',
    unknownUser: 'Ukjent bruker',
  },
  navigation: {
    dashboard: 'Dashbord',
    eosDashboard: 'Oversikt',
    devices: 'Enheter',
    map: 'Kart',
    buildings: 'Bygninger',
    reports: 'Rapporter',
    settings: 'Innstillinger',
    logout: 'Logg ut',
    sastech: 'Sastech Innstillinger',
    analytics: 'Analyse',
    buildings3D: 'Bygninger3D',
    superSettings: 'Sastech',
    buildingInspection: 'Befaring',
    expandSidebar: 'Utvid sidemeny',
    collapseSidebar: 'Skjul sidemeny',
    userCalendar: 'Brukerkalender',
    energyLabelLeads: 'Energimerke leads',
  },
  reports: {
    title: 'Rapporter',
    orderReport: 'Bestill rapport',
    orderDescription: 'Rapporten dukker opp i listen når den er klar.',
    reportType: 'Rapporttype',
    kinds: {
      eos_weekly: 'Ukesrapport energi',
      eos_monthly: 'Månedsrapport energi',
    },
    period: 'Periode',
    week: 'Uke {week}',
    reportLanguage: 'Rapportspråk',
    submit: 'Bestill',
    submitting: 'Bestiller…',
    status: {
      queued: 'I kø',
      generating: 'Lages',
      completed: 'Klar',
      failed: 'Feilet',
    },
    exportExcel: 'Last ned Excel',
    exportPdf: 'Last ned PDF',
    makePdf: 'Lag PDF',
    pdfPending: 'PDF lages…',
    confirmDeleteTitle: 'Slett rapport',
    confirmDeleteMessage:
      'Rapporten fjernes fra listen. Dette kan ikke angres.',
    noReports: 'Ingen rapporter ennå. Bestill den første.',
    noSearchHits: 'Ingen rapporter passer søket.',
    noMeters: 'Bygningen har ingen aktive energimålere.',
    duplicateOrder: 'Samme rapport lages allerede.',
    orderError: 'Kunne ikke bestille rapporten',
    orderSuccess: 'Rapporten er bestilt og lages nå.',
    deleteError: 'Kunne ikke slette rapporten',
    pdfError: 'Kunne ikke bestille PDF',
    pdfRequested: 'PDF er bestilt og lages nå.',
    requestedBy: 'Bestilt av',
    ordered: 'Bestilt',
    daysAgo: '{count} dager siden',
    sheets: {
      summary: 'Sammendrag',
      days: 'Per dag',
      hours: 'Per time',
      sources: 'Målere',
      profile: 'Døgnprofil',
    },
    excel: {
      parameter: 'Parameter',
      value: 'Verdi',
      unit: 'Enhet',
      delivered: 'Levert energi',
      production: 'Egenprodusert',
      export: 'Eksportert',
      net: 'Brukt i bygget',
      baseline: 'Baseline',
      previousYear: 'Forrige år',
      co2: 'CO2',
      baselineCo2: 'CO2 baseline',
      hoursWithData: 'Timer med data',
      meanKW: 'Gjennomsnittlig effekt',
      maxKW: 'Høyeste time',
      maxAt: 'Høyeste time, tidspunkt',
      baseLoadKW: 'Grunnlast',
      nightKW: 'Nattlast 00–05',
      peakHours: 'Timer på eller over 90 % av maks',
      weekday: 'Ukedag',
      time: 'Time',
      source: 'Måler',
      missingHours: 'Manglende timer',
      energy: 'Energi',
      co2Factor: 'CO2 faktor',
      role_delivered: 'levert energi',
      role_production: 'egenproduksjon',
      role_export: 'eksport',
      role_excluded: 'ikke medregnet',
    },
  },
  map: {
    addBuildingAtCenter: 'Legg til bygning i kartets sentrum',
  },
  pagination: {
    rowsPerPage: 'Rader per side',
    rangeSeparator: 'av',
  },

  devices: {
    title: 'Enhetsoversikt',
    reset: 'Tilbakestill',
    noDevices: 'Ingen enheter funnet.',
    unnamed: 'Navnløs enhet',
    copySensorTag: 'Kopier sensortag',
    graph: {
      inspect: 'Inspiser',
      edit: 'Rediger',
      chartType: 'Diagramtype',
      toggleSeries: 'Veksle serier',
      resetFilters: 'Tilbakestill filtre',
      exportData: 'Eksporter data',
      noData: 'Ingen data',
      bar: 'Stolpe',
      line: 'Linje',
      pie: 'Kakediagram',
      scatter: 'Spredning',
      radar: 'Radar',
    },
    categoryFilter: {
      filter: 'Filtrer',
      filterByCategory: 'Filtrer etter kategori',
      selectAll: 'Velg alle',
      clearAll: 'Fjern alle',
      searchCategories: 'Søk i kategorier...',
      noCategories: 'Ingen kategorier funnet',
      noData: 'Ingen data',
      devices: 'enheter',
      selected: 'Valgte',
      category: 'kategori',
      categories: 'kategorier',
      more: 'flere',
    },
    detailLevel: {
      label: 'Detaljnivå',
      units: {
        minutes: 'Minutter',
        minutesShort: 'min',
        day: 'Døgn',
      },
    },
    dateRange: {
      startLabel: 'Startdato',
      endLabel: 'Sluttdato',
    },
    eosConsumption: {
      card: {
        dateLabel: 'Dato',
        total: {
          production: 'Total produksjon:',
          consumption: 'Total forbruk:',
        },
        highestPeak: 'Høyeste topp:',
        calculatedPrice: {
          eur: 'Beregnet pris (EUR):',
          nok: 'Beregnet pris (NOK):',
        },
      },
    },
  },

  analytics: {
    session: {
      moreActions: 'Flere handlinger',
      newSession: 'Ny økt',
      unsaved: 'Ulagrede endringer',
      namePlaceholder: 'Navn på økt',
      deleteTitle: 'Slette økten?',
      deleteDescription:
        'Dette fjerner den lagrede økten og enhetsutvalget permanent.',
      noSessions: 'Ingen lagrede økter',
      discardTitle: 'Forkaste ulagrede endringer?',
      discardDescription:
        'Den gjeldende økten har endringer som ikke er lagret. Bytter du nå, mister du dem.',
    },
    notifications: {
      overlayMissingZone:
        'Bygget har ingen sone konfigurert. Bruker standard (NO1).',
      overlayMissingRate: 'Kunne ikke hente valutakurs',
      overlayFetchFailed: 'Kunne ikke hente overleggsdata',
      sessionSaved: 'Økten er lagret',
      sessionCreated: 'Økten er opprettet',
      sessionDeleted: 'Økten er slettet',
      sessionSaveFailed: 'Kunne ikke lagre økten',
      sessionDeleteFailed: 'Kunne ikke slette økten',
      sessionsLoadFailed: 'Kunne ikke laste lagrede økter',
      devicesLoadFailed: 'Kunne ikke laste enheter',
      buildingsLoadFailed: 'Kunne ikke laste bygg',
      readingsLoadFailed:
        'Kunne ikke laste målinger for én eller flere enheter',
      nameRequired: 'Gi økten et navn før du lagrer',
      rangeTooWide:
        'Perioder over 7 dager er trege med dette intervallet. Bytt til Daglig for bedre ytelse.',
    },
    title: 'Sanntidsanalyse & KPI-er',
    pageTitle: 'Analyse',
    searchPlaceholder: 'Søk enheter…',
    buttons: {
      toggleSidebar: 'Vis/skjul enhetsliste',
      showAll: 'Vis alle',
      hideAll: 'Skjul alle',
      showTrends: 'Vis trender',
      hideTrends: 'Skjul trender',
      clearAll: 'Tøm alle',
      export: 'Eksporter',
    },
    exportMenu: {
      exportAsPNG: 'Eksporter som PNG',
      exportAsCSV: 'Eksporter som CSV',
    },
    thresholds: {
      max: 'Maks:',
      min: 'Min:',
      aboveThreshold: 'Over terskel',
      belowThreshold: 'Under terskel',
    },
    timeAxis: {
      label: 'Tidsakse',
      actual: 'Faktisk tid',
      timeOfDay: 'Tid på døgnet',
      dayOfWeek: 'Ukedag',
      dayOfMonth: 'Dag i måneden',
      bucket: 'Grupper etter',
    },
    legend: {
      manage: 'Behandle',
      overlays: 'Overlegg',
      series: 'Serier',
      trends: 'Trender',
      more: 'flere',
    },
    overlay: {
      weatherAndElectricity: 'Vær & Elektrisitet',
      none: 'Ingen',
      outsideTemperature: 'Utetemperatur',
      elecPrice: 'Strømpris',
      elecPriceFull: 'Strømpris (kr/kWh)',
      loadingData: 'Laster data...',
    },
    collab: {
      viewingSession: 'ser på denne økten',
      updatedSession: 'oppdaterte denne økten',
      deletedSession: 'slettet denne økten',
      conflictTitle: 'Noen har lagret en nyere versjon',
      conflictDescription:
        'Denne økten ble lagret av noen andre mens du redigerte. Last inn deres versjon (dine endringer går tapt) eller overskriv med din.',
      loadTheirs: 'Last inn deres versjon',
      overwrite: 'Overskriv',
    },
    picker: {
      wholeBuilding: 'Hele bygget',
      noClimateSources: 'Ingen bygg med soner',
      noAveragesData: 'Ingen klimadata ennå',
      noIndoorSensors: 'Bygget har ingen innendørssensorer',
      inSession: 'I økten',
      searchBuildings: 'Søk i bygg…',
      noBuildingsMatch: 'Ingen bygg samsvarer',
      noWeatherData: 'Ingen værdata ennå',
    },
    devices: {
      noDevicesMatch: 'Ingen enheter funnet',
      unnamedDevice: 'Navnløs enhet',
      noDevicesSelected: 'Ingen enheter valgt',
      devicesFound: 'enheter funnet',
      noDevicesMatchSearch: 'Ingen enheter matcher søket ditt',
      deviceSelected: 'enhet valgt',
      devicesSelected: 'enheter valgt',
      shown: 'vist',
      total: 'totalt',
    },
    chart: {
      zoomHint: 'Zoomet (dobbeltklikk for å nullstille)',
      loadingChartData: 'Laster diagramdata...',
      addDevicesToVisualize: 'Legg til enheter for å visualisere data',
    },
    liveEvents: {
      title: 'Sanntidshendelser',
      events: 'hendelser',
      waitingForEvents: 'Venter på hendelser…',
    },
    modal: {
      weatherIntervalHint: 'Værdata har timesoppløsning',
      deviceSettings: 'Enhetsinnstillinger',
      addDevices: 'Legg til enheter',
      clear: 'Fjern',
      startTime: 'Starttid',
      endTime: 'Sluttid',
      samplingInterval: 'Samplingsintervall',
      dataAggregationGranularity: 'Dataaggregeringsgranularitet',
      startMustBeBeforeEnd: 'Start må være før slutt',
      intervals: {
        fiveMinutes: '5 minutter',
        fifteenMinutes: '15 minutter',
        oneHour: '1 time',
        daily: 'Daglig',
      },
    },
    connectionStatus: {
      error: 'FEIL',
      connected: 'TILKOBLET',
      connecting: 'KOBLER TIL',
      disconnected: 'FRAKOBLET',
    },
  },

  eosDashboard: {
    headerTitle: 'Energioverblikk',
    energyKnowledge: {
      title: 'Energianalyse',
      lastMonth: 'Forrige måned',
    },
    building: 'Bygning',
    selectBuilding: 'Velg bygning',
    outdoorTemperature: 'Utendørstemperatur',
    noData: 'I/T',
    electricityPrice: 'Strømpris',
    electricityPrices: 'Strømpriser',
    noPriceData: 'Ingen prisdata tilgjengelig.',
    electricityConsumption: 'Strømforbruk',
    baseline: 'Baseline',
    viewLabel: 'Visning:',
    aggregated: 'Aggregert',
    meteringPoint: 'Målepunkt:',
    individualTitle: 'Individuelle målepunkter',
    eosSourcesTitle: 'Individuelle EOS kilder',
    footprint: 'CO₂-avtrykk (reduksjon)',
    co2Footprint: 'CO₂ Avtrykk',
    consumption: 'Forbruk',
    avgMaxKwp: 'Gjennomsnittlig maks kWp',
    higher: 'Høyere',
    lower: 'Lavere',
    normal: 'Normal',
    priceWord: 'pris',
    vsAverage: 'Mot snitt',

    baselineChart: {
      total: 'Totalt',
      average: 'Gjennomsnitt',
      leftAxis: 'kWh (Forbruk)',
      rightAxis: 'kWp (Maks gjennomsnitt)',
      co2Avg: 'CO₂ Gjennomsnitt',
      missingData: 'Manglende data',
      missingDataDescription: 'Verdier mangler for denne måneden',
    },
    energyLabel: {
      title: 'Dynamisk energimerke',
      withoutSastech: 'Offisiell merking',
      withSastech: 'Dynamisk merking',
      deliveredEnergy: 'Beregnet levert energi',
      insufficientData:
        'Kun {months} måneders data tilgjengelig. Merket er kanskje ikke representativt.',
      noFloorArea: 'Netto bruksareal er ikke satt for denne bygningen.',
      noBuildingCategory: 'Bygningskategori er ikke satt for denne bygningen.',
      fossilFuelShare: 'Andel strøm/olje/gass',
      reduction: 'Reduksjon',
      floorArea: 'Bruksareal',
      annualConsumption: 'Årlig',
      energyGrade: 'Energiklasse',
      labels: {
        A: 'Svært energieffektiv',
        B: 'Energieffektiv',
        C: 'Moderat effektivitet',
        D: 'Under gjennomsnittet',
        E: 'Dårlig effektivitet',
        F: 'Svært dårlig effektivitet',
        G: 'Minst effektiv',
      },
    },
    kpiSection: {
      trend: {
        aboveAverage: 'Over',
        belowAverage: 'Under',
        atAverage: 'På',
        averageThisPeriod: 'gjennomsnitt denne perioden',
      },

      consumption: {
        title: 'Totalt forbruk',
        subtitle: {
          increased: 'Økt med {delta} {unit}',
          reduced: 'Redusert med {delta} {unit}',
          noChange: 'Ingen endring i forbruk',
          noBaseline: 'Ingen referansedata tilgjengelig',
        },
        detail: 'Energiforbruk siste {periodLabel}',
      },

      co2: {
        title: 'Totalt CO₂-avtrykk',
        subtitle: {
          reduced: 'Redusert med {delta} {unit}',
          increased: 'Økt med {delta} {unit}',
          noChange: 'Ingen endring i utslipp',
          noBaseline: 'Ingen referansedata tilgjengelig',
        },
        detail: 'Karbonavtrykk siste {periodLabel}',
      },

      adjustedConsumption: {
        title: 'Graddagsjustert forbruk',
      },

      estate: {
        title: 'Bygninger og kilder',
        value: '{count} bygninger',
        subtitle: '{count} totale kilder',
        detail: 'For øyeblikket {count} aktive enheter',
      },

      price: {
        title: 'Nåværende pris',
        subtitle: '{direction} {avgPhrase}',
        detail: 'Strømpris akkurat nå',
      },

      temperature: {
        title: 'Temperatur',
        subtitleText: '{text}',
        detail: 'Gjeldende værforhold',
      },
    },
    savingsSection: {
      consumptionComparison: {
        title: 'Forbruksammenligning - fjorår vs. hittil i år',
        baseLineLabel: 'Baseline',
        peakHourlyLabel: 'Høyeste topp',
      },
      consumptionSavings: {
        title: `Forbrukssparing - baseline vs. {{currentYear}}`,
      },
    },
    electricityChart: {
      totalLabel: 'Totalt',
      totalEnergyConsumption: 'Totalt energiforbruk',
      totalElectricityConsumption: 'Totalt strømforbruk',
      energyConsumption: 'Energiforbruk',
      electricityConsumption: 'Strømforbruk',
      noDataForSelectedPeriod: 'Ingen data for valgt periode',
      meteringPointTitle: 'Målepunkt: {id}',
      sourceTitle: 'Kilde: {id}',
      unknownLabel: 'Ukjent',
      unknownIdLabel: 'Ukjent ID',
      powerFactorLabel: 'Effektfaktor Cos φ',
      powerFactorWarning: 'Effektfaktor under 0,95 kan medføre tariffpåslag',
      renameDialog: {
        title: 'Gi målepunkt nytt navn',
        label: 'Visningsnavn',
        helpTextPrefix: 'Opprinnelig målepunkt-ID',
      },
      errors: {
        loadAggregatedData: 'Kunne ikke laste aggregerte data',
        loadFilteredData: 'Kunne ikke laste filtrerte data',
        fetchDisplayName: 'Kunne ikke hente visningsnavn',
        invalidDisplayName: 'Vennligst oppgi et gyldig visningsnavn',
        renameFailed: 'Kunne ikke gi EOS-enheten nytt navn',
        renameUnknown: 'Det oppstod en feil ved endring av navn på EOS-enheten',
        noDataToExport: 'Ingen data tilgjengelig for eksport',
        exportFailedTitle: 'Eksport mislyktes',
        exportFailedPrefix: 'Eksport av data mislyktes',
        unknownError: 'Ukjent feil',
        enterValidDisplayName: 'Vennligst skriv inn et gyldig visningsnavn',
        validationErrorTitle: 'Valideringsfeil',
      },
      tooltip: {
        electricityElhub: 'Elektrisitet',
        reactiveEnergy: 'Reaktiv energi',
        buildingsLabel: 'Bygninger',
        meteringPointsLabel: 'Målepunkter',
        districtHeating: 'Fjernvarme',
        solarPv: 'Produsert solenergi',
        exportedElectricity: 'Eksportert strøm',
      },
    },
    co2BarChart: {
      baseline: 'Referanse',
      legendBaseline: 'Baseline',
      currentValues: 'Nåverdier',
      co2Emissions: 'CO₂-utslipp',
      dailyEmissions: 'Daglige utslipp',
      monthlyEmissions: 'Månedlige utslipp',
      months: [
        'Januar',
        'Februar',
        'Mars',
        'April',
        'Mai',
        'Juni',
        'Juli',
        'August',
        'September',
        'Oktober',
        'November',
        'Desember',
      ],
      goal: 'Mål',
    },
    chartMenu: {
      rename: 'Gi nytt navn',
      exportExcel: 'Eksporter Excel',
      exportCSV: 'Eksporter CSV',
    },

    periodOptions: {
      '3days': {
        label: 'Siste 3 dager',
        mobileLabel: '3 dager',
        chartLabel: '3 dager',
      },
      '30days': {
        label: 'Siste 30 dager',
        mobileLabel: '30 dager',
        chartLabel: '30 dager',
      },
      '3months': {
        label: 'Siste 3 måneder',
        mobileLabel: '3 måneder',
        chartLabel: '3 måneder',
      },
    },
    chartSubtitle: {
      today: 'Totalt for i dag',
      oneDay: 'Totalt for 1 dag',
      days: 'Totalt for {days} dager',
      oneWeek: 'Totalt for 1 uke',
      weekAndDays: 'Totalt for 1 uke og {days} dag(er)',
      weeks: 'Totalt for {weeks} uker',
      weeksAndDays: 'Totalt for {weeks} uker og {days} dag(er)',
      months: 'Totalt for {months} måneder',
      monthsAndDays: 'Totalt for {months} måneder og {days} dag(er)',
      monthsAndWeeks: 'Totalt for {months} måneder og {weeks} uke(r)',
    },
    datePicker: {
      startLabel: 'Start',
      endLabel: 'Slutt',
    },
    weatherTemperature: {
      noData: 'Ingen værdata tilgjengelig',
      headerTitle: 'Værvarsel',
      headerSubtitle: 'Prognose',
      tooltip: {
        conditions: 'Forhold',
        temperature: 'Temperatur',
        wind: 'Vind',
        windDirection: 'Vindretning',
        pressure: 'Trykk',
        cloudCover: 'Skydekke',
        fog: 'Tåke',
        uvIndex: 'UV-indeks',
        precipitation: 'Nedbør neste timen',
      },
      stats: {
        min: 'Min',
        avg: 'Snitt',
        max: 'Maks',
        current: 'Nå',
      },
    },
    tempTrend: {
      stable: 'Stabil utetemperatur',
      graduallyRising: 'Gradvis stigende temperatur',
      graduallyFalling: 'Gradvis synkende temperatur',
      rising: 'Stigende utetemperatur',
      falling: 'Synkende utetemperatur',
    },
    noDataForPeriod: 'Ingen energidata for valgt periode',
    totalEnergy: 'Total energi',
    filters: {
      noMatch: 'Ingen noder passer alle valgte kategorier',
    },
    staleData: {
      warningText: 'gårsdagens data er ikke tilgjengelig',
      showingDataFrom: 'Viser data fra',
    },
    sankey: {
      noData: 'Ingen sankeydata tilgjengelig.',
      searchNodes: 'Søk noder...',
      selectedNodes: 'Valgte noder',
      csvValue: 'Verdi (kWh)',
      csvDeviceId: 'Enhets ID',
    },
  },

  superSettings: {
    securityLog: {
      title: 'Sikkerhetslogg',
      levelBadge: 'Nivå 10',
      intro:
        'Innlogginger, endringer, datatilgang og API-bruk på tvers av alle kunder. Innlogginger, endringer og datatilgang lagres i 90 dager, bruk i 30 dager.',
      error: 'Sikkerhetsloggen kunne ikke lastes.',
      tabs: {
        overview: 'Oversikt',
        logins: 'Innlogginger',
        changes: 'Endringer',
        reads: 'Datatilgang',
        usage: 'Bruk',
        sessions: 'Økter',
      },
      filters: {
        period: 'Periode',
        last24h: 'Siste 24 timer',
        last7d: 'Siste 7 dager',
        last30d: 'Siste 30 dager',
        last90d: 'Siste 90 dager',
        custom: 'Egendefinert',
        vendor: 'Kunde',
        allVendors: 'Alle kunder',
        exportCsv: 'Eksporter CSV',
        refresh: 'Oppdater',
      },
      totals: {
        logins: 'Innlogginger',
        loginsHint: '{users} brukere, {ips} IP-er',
        reads: 'Datatilgang',
        readsHint: '{users} brukere',
        readsTooltip: 'Lesinger av brukerlister, kundelister, leads og logger',
        failedLogins: 'Mislykkede innlogginger',
        rateLimitedHint: '{count} stoppet av hastighetsgrensen',
        changes: 'Endringer',
        deletesHint: '{count} slettinger',
        accessChanges: 'Tilgangsendringer',
        accessHint: 'Nivåer, kundetilgang, Entra ID',
        requests: 'API-forespørsler',
        requestsHint: '{users} aktive brukere',
        compromised: 'Mulig kompromittert',
        compromisedHint: 'Kontoer å sjekke',
        unknownOutcome:
          '{count} innlogginger fra før utfall ble registrert telles for seg.',
        truncated:
          'Perioden er stor; bare de første 20 000 oppføringene ble sjekket.',
      },
      attention: {
        title: 'Trenger oppmerksomhet',
        empty: 'Ingenting trenger oppmerksomhet i denne perioden.',
        high: 'Høy',
        medium: 'Middels',
        low: 'Lav',
        showMore: 'Vis alle {count}',
      },
      compromised: {
        title: 'Mulig kompromitterte kontoer',
        empty: 'Ingen kontoer viser tegn på å være kompromittert.',
        help: 'Bruk ingen person kan stå for, eller én økt brukt fra flere steder samtidig.',
      },
      chart: {
        title: 'Innlogginger per dag',
        success: 'Vellykket',
        failed: 'Mislykket',
        rateLimited: 'Hastighetsbegrenset',
      },
      sensitive: {
        title: 'Siste tilgangsendringer',
        empty: 'Ingen tilgangsendringer i denne perioden.',
      },
      alerts: {
        failedLoginsThenSuccess:
          '{count} mislykkede innlogginger for {who}, deretter en vellykket innlogging',
        failedLogins: '{count} mislykkede innlogginger for {who}',
        failedLoginsIp:
          '{count} mislykkede innlogginger fra {ip}, mot {accounts} kontoer',
        rateLimited: '{count} stoppede innloggingsforsøk for {who}',
        newIp: '{who} logget inn fra en ny IP-adresse ({ip})',
        levelRaised: '{who} hevet fra nivå {old} til {new} av {by}',
        accessChange: 'Tilgang endret for {who} ({fields}) av {by}',
        userDeleted: '{who} ble slettet av {by}',
        massDelete: '{who} slettet {count} poster innen 10 minutter',
        requestBurst: '{who} gjorde {count} forespørsler på ett minutt',
        alwaysOn: '{who} var aktiv {count} timer på ett døgn',
        parallelLocations: '{who} ble brukt fra {count} IP-adresser samtidig',
        parallelDevices: '{who} ble brukt fra {count} enheter samtidig',
        robotRhythm:
          '{who} sendte forespørsler i maskinmessig jevnt tempo i {count} minutter',
        changeBurst: '{who} gjorde {count} endringer innen 10 minutter',
        vendorHopping: '{who} jobbet i {count} kunder innen én time',
        readBurst: '{who} leste kritiske data {count} ganger innen 10 minutter',
        unknown: 'Ukjent varsel',
        someone: 'ukjent konto',
        occurrences: '{count} ganger i perioden',
      },
      alertNames: {
        failedLoginsThenSuccess: 'Innlogging etter mange feil',
        failedLogins: 'Mange mislykkede innlogginger',
        failedLoginsIp: 'IP med mange feil',
        rateLimited: 'Hastighetsbegrenset',
        newIp: 'Ny IP-adresse',
        levelRaised: 'Nivå hevet',
        accessChange: 'Tilgang endret',
        userDeleted: 'Bruker slettet',
        massDelete: 'Massesletting',
        requestBurst: 'Forespørselstopp',
        alwaysOn: 'Alltid på',
        parallelLocations: 'Flere steder samtidig',
        parallelDevices: 'Flere enheter samtidig',
        robotRhythm: 'Maskinmessig tempo',
        changeBurst: 'Endringstopp',
        vendorHopping: 'Kundehopping',
        readBurst: 'Masselesing',
      },
      logins: {
        time: 'Tid',
        outcome: 'Utfall',
        method: 'Metode',
        account: 'Konto',
        vendor: 'Kunde',
        ip: 'IP-adresse',
        device: 'Enhet',
        allOutcomes: 'Alle utfall',
        allFailures: 'Alle feil',
        allMethods: 'Alle metoder',
        searchEmail: 'Søk e-post',
        searchIp: 'IP-adresse',
        filterByIp: 'Vis innlogginger fra denne IP-en',
        filterByAccount: 'Vis innlogginger for denne kontoen',
        empty: 'Ingen innlogginger passer filtrene.',
      },
      outcomes: {
        success: 'Vellykket',
        wrong_password: 'Feil passord',
        unknown_user: 'Ukjent bruker',
        inactive: 'Deaktivert',
        invalid_input: 'Ugyldig input',
        rate_limited: 'Hastighetsbegrenset',
        unknown_vendor: 'Ukjent tenant',
        invalid_session: 'Ugyldig økt',
        unknown: 'Ikke registrert',
      },
      methods: {
        password: 'Passord',
        entra: 'Entra ID',
      },
      changes: {
        time: 'Tid',
        action: 'Handling',
        collection: 'Samling',
        record: 'Post',
        by: 'Av',
        vendor: 'Kunde',
        endpoint: 'Forespørsel',
        history: 'Historikk',
        allActions: 'Alle handlinger',
        create: 'Opprettet',
        update: 'Oppdatert',
        delete: 'Slettet',
        collectionPlaceholder: 'Samling, for eksempel users',
        fieldPlaceholder: 'Felt, for eksempel level',
        empty: 'Ingen endringer passer filtrene.',
        filterByUser: 'Vis endringer gjort av denne brukeren',
      },
      reads: {
        time: 'Tid',
        user: 'Bruker',
        area: 'Hva',
        vendor: 'Kunde',
        ip: 'IP-adresse',
        device: 'Enhet',
        allAreas: 'Alt unntatt sikkerhetsloggen',
        everything: 'Alt, også sikkerhetsloggen',
        searchIp: 'IP-adresse',
        filterByUser: 'Vis lesinger av denne brukeren',
        filterByIp: 'Vis lesinger fra denne IP-en',
        empty: 'Ingen lesinger passer filtrene.',
        note: 'Lesinger av brukerlister, kundelister, leads og logger, lagret i 90 dager.',
      },
      readAreas: {
        vendors: 'Kundeliste',
        users: 'Brukerliste',
        alarmUsers: 'Alarmbrukere',
        energyLabelLeads: 'Energimerke-leads',
        enerskyAccess: 'Enersky-tilgang',
        feedback: 'Tilbakemeldinger',
        requestLogs: 'Forespørselslogger',
        securityLog: 'Sikkerhetslogg',
        other: 'Annet',
      },
      usage: {
        user: 'Bruker',
        requests: 'Forespørsler',
        peak: 'Topp per minutt',
        activeMinutes: 'Aktive minutter',
        ips: 'IP-er',
        devices: 'Enheter',
        vendors: 'Kunder',
        flags: 'Flagg',
        flaggedOnly: 'Bare brukere med flagg',
        compromisedBadge: 'Mulig kompromittert',
        empty: 'Ingen API-bruk i denne perioden.',
        note: 'API-bruk lagres i 30 dager.',
      },
      sessions: {
        user: 'Bruker',
        rights: 'Rettigheter',
        method: 'Metode',
        ip: 'IP-adresse',
        device: 'Enhet',
        started: 'Logget inn',
        lastSeen: 'Sist sett',
        status: 'Status',
        open: 'Åpen',
        revoked: 'Avsluttet',
        expired: 'Utløpt',
        idle: 'Inaktiv',
        level: 'Nivå {level}',
        tenants: '+{count} kunder',
        openOnly: 'Bare åpne økter',
        revoke: 'Avslutt',
        revokeTitle: 'Avslutte denne økten?',
        revokeText: 'Økten til {who} ({method}, {ip}) avsluttes.',
        cancel: 'Avbryt',
        revokeFailed: 'Økten kunne ikke avsluttes.',
        empty: 'Ingen økter passer filtrene.',
        note: 'En økt slutter {absolute} timer etter innlogging, eller etter {idle} timer uten bruk. Økter lagres i 90 dager.',
        notEnforced:
          'Økter registreres, men håndheves ikke ennå. Å avslutte en økt markerer den som avsluttet; brukeren logges ut når håndhevingen slås på.',
      },
      history: {
        title: 'Posthistorikk',
        empty: 'Ingen registrerte endringer for denne posten.',
        close: 'Lukk',
        open: 'Vis historikken for denne posten',
      },
    },
    areasMenu: {
      securityLog: 'Sikkerhetslogg',
      createDashboard: 'Opprett dashbord',
      feedback: 'Tilbakemelding',
      projects: 'Prosjekter',
      icMeter: 'IC-måler',
      lakeSensors: 'Innsjøsensorer',
      eosDevices: 'EOS-enheter',
      deviceMapping: 'Enhetskartlegging',
      energyLabeling: 'Energimerking',
      alarmSystems: 'Alarmsystemer',
      enerskyAccess: 'Enersky-tilgang',
    },
    dataQuality: {
      title: 'Datakvalitetsinspektør',
      subtitle:
        'Sanntidsoversikt over alle sensorgrupper og enheters datastatus.',
      noLakes: 'Ingen sensorgrupper funnet',
      noDevices: 'Ingen enheter',
      allReporting: 'Alle rapporterer',
      missing: 'mangler',
      device: 'enhet',
      devices: 'enheter',
      missingData: 'Manglende data',
    },
    createDashboard: {
      header: 'Nytt kundedashbord',
      sections: {
        companyDetails: 'Firmadetaljer',
        address: 'Adresse',
        contactDetails: 'Kontaktinformasjon',
      },
      fields: {
        companyName: 'Firmanavn',
        organizationNumber: 'Organisasjonsnummer',
        street: 'Gate',
        city: 'By',
        postcode: 'Postnummer',
        country: 'Land',
        email: 'E-post',
        phoneNumber: 'Telefonnummer',
        timezone: 'Kundens lokale tidssone',
      },
      helperText: {
        organizationNumber: 'Foretaks-/organisasjonsnummer',
        timezone: 'Velg kundens lokale tidssone',
      },
      buttons: {
        cancel: 'Avbryt',
        createClient: 'Opprett kunde',
      },
    },
    sastechFeedback: {
      title: 'Sastech Tilbakemeldinger',
      table: {
        title: 'Tilbakemeldinger',
        message: 'Melding',
        actions: 'Handlinger',
        resolved: 'Løst',
        resolvedBy: 'av',
        unResolved: 'Uløst',
        customerFeedback: 'Tilbakemelding fra kunde',
        filter: 'Filter',
        developerFeedback: 'Tilbakemelding fra utvikler',
        comment: 'Kommentar',
        hasDeveloperResponse: 'Kommentar fra utvikler',
        assignDeveloper: 'Tildel utvikler',
        suggestedAction: 'Foreslått tiltak',
        tags: 'Tagger',
        noTagsProvided: 'Ingen tagger oppgitt',
        vote: 'Stem',
        resolvedTicketsThisWeek: 'Løste tilbakemeldinger denne uken',
        last7Days: 'Siste 7 dager',
        newTicketsThisWeek: 'Nye tilbakemeldinger denne uken',
        featureTicketsThisWeek: 'Features denne uken',
        bugTicketsThisWeek: 'Bugs denne uken',
        resolvedTickets: 'Løste tilbakemeldinger',
      },
      buttons: {
        resolve: 'Løs',
        save: 'Lagre svar',
      },
      confirm: {
        resolve: 'Er du sikker på at du vil løse denne tilbakemeldingen?',
        delete: 'Er du sikker på at du vil slette denne tilbakemeldingen?',
      },
      details: {
        browserInfo: 'Nettleserinfo:',
        type: 'Type',
        device: 'Enhet',
        operatingSystem: 'Operativsystem',
        path: 'Sti',
        resolution: 'Oppløsning',
        na: 'ikke tilgjengelig',
        screenshotAlt: 'skjermbilde',
      },
    },
    alarmSystems: {
      titleEdit: 'Rediger alarmsystem',
      titleCreate: 'Opprett alarmsystem',
      accordion: {
        details: 'Alarmdetaljer',
        heartbeat: 'Hjerte­slagdetaljer',
        notification: 'Varslingsdetaljer',
        connectedDevices: 'Tilkoblede enhetsalarmer',
      },
      fields: {
        systemName: 'Alarmsystemnavn',

        location: 'Plassering',
      },
      heartbeat: {
        explanation:
          'Hjerte­slagintervallet er tiden i sekunder mellom hvert signal som sendes av alarmsystemet til serveren. Dette signalet indikerer at systemet er aktivt og fungerer som det skal. Hvis serveren ikke mottar et signal innen angitt tid, kan det indikere et problem med systemet.',
        monitor: 'Hjerte­slagsmonitor',
        hours: 'Timer',
        minutes: 'Minutter',
        seconds: 'Sekunder',
      },
      notification: {
        type: 'Varslingstype',
        selectType: 'Velg varslings­type',
        options: {
          sms: 'SMS',
        },
        recipient: 'Mottaker av varsel',
        recipients: 'Mottakere av varsel',
        selectUser: 'Velg bruker',
        orAddManually: 'Eller legg til e-post eller mobilnummer manuelt:',
        addRecipient: 'Legg til mottaker',
        contact: 'E-post / mobilnummer',
        minimumSeverity: 'Laveste alvorlighetsgrad',
        severityLevels: {
          1: 'Info',
          2: 'Advarsel',
          3: 'Mindre',
          4: 'Alvorlig',
          5: 'Kritisk',
        },
        errors: {
          empty: 'Mottaker kan ikke være tomt',
          duplicate: 'Denne mottakeren er allerede lagt til',
          invalidEmail: 'Ugyldig e-postformat',
          selectTypeFirst: 'Velg først varslings­type',
          enterEmail: 'Skriv inn en e-postadresse',
          enterMobile: 'Skriv inn et mobilnummer',
        },
      },
      connectedDevices: {
        empty: 'Ingen enhetsalarmer er koblet til dette alarmsystemet.',
        unnamed: 'Navnløs alarm',
      },
      confirmDelete: 'Er du sikker på at du vil slette dette alarmsystemet?',
      list: {
        new: 'Ny',
        search: 'Søk...',
        empty: 'Ingen alarmsystemer funnet',
      },
      updatedSuccess: 'Alarmsystem oppdatert',
      createdSuccess: 'Alarmsystem opprettet',
      deletedSuccess: 'Alarmsystem slettet',
      updateError: 'Feil ved oppdatering av alarmsystem',
      createError: 'Feil ved opprettelse av alarmsystem',
      deleteError: 'Feil ved sletting av alarmsystem',
      fetchError: 'Feil ved henting av alarmsystemer',
      fetchLogsError: 'Feil ved henting av alarmlogger',
    },
    enerskyAccess: {
      list: {
        header: 'Enersky-tilgangsregistreringer',
        description:
          'Administrer datadeling-tilgang og kontraktstatus for kunder',
        tableTitle: 'Tilgangsregistreringer',
        addButton: 'Opprett registrering',
        emptyState: 'Ingen registreringer funnet.',
        searchPlaceholder: 'Søk i eksisterende registreringer…',
        backButton: 'Tilbake til registreringer',
      },

      columns: {
        vendor: 'Leverandør',
        customer: 'Kunde',
        status: 'Status',
      },

      validation: {
        missingVendor: 'Leverandør er påkrevd.',
        missingFirstName: 'Fornavn er påkrevd.',
        missingLastName: 'Etternavn er påkrevd.',
        missingEmail: 'E-postadresse må være oppgitt og i riktig format.',
        missingCompanyName: 'Firmanavn er påkrevd for bedriftskunder.',
        missingOrganizationNumber: 'Organisasjonsnummer er påkrevd.',
        missingNationalId: 'Fødselsnummer er påkrevd.',
      },

      feedback: {
        save: {
          missingInfoTitle: 'Manglende informasjon',
          missingInfoMessage: 'Vennligst fyll ut alle påkrevde felter.',
          createSuccessTitle: 'Registrering opprettet',
          createSuccessMessage:
            'Registrering opprettet og kontraktse-post sendt.',
          updateSuccessTitle: 'Oppdatert',
          updateSuccessMessage: 'Kontaktopplysningene ble oppdatert.',
          errorTitle: 'Feil',
          errorMessage: 'Lagring mislyktes.',
          duplicateEndUser: 'Denne kunden finnes allerede i Enersky.',
        },

        refresh: {
          mpidsTitle: 'Abonnementer oppdatert',
          mpidsMessage: 'MPID-status oppdatert.',
          statusTitle: 'Status oppdatert',
          statusMessage: 'Registreringsstatus og MPID-er oppdatert.',
          errorTitle: 'Feil',
          errorMessage: 'Oppdatering av data mislyktes.',
        },

        resend: {
          title: 'E-post sendt',
          message: 'Kontraktse-post ble sendt på nytt til kunden.',
          errorTitle: 'Feil',
          errorMessage: 'Kunne ikke sende kontraktse-post på nytt.',
        },

        history: {
          title: 'Forespørsel om historiske data lagt i kø',
          message: 'Data lagt i kø.',
          errorTitle: 'Feil',
          errorMessage: 'Kunne ikke legge måleverdier i kø.',
        },

        delete: {
          successTitle: 'Registrering slettet',
          successMessage: 'Enersky-tilgangsregistreringen er slettet.',
          errorTitle: 'Feil',
          errorMessage: 'Sletting av registrering mislyktes.',
        },
      },

      editEnerskyAccess: {
        labels: {
          basicInfo: 'Grunnleggende informasjon',
          vendor: 'Leverandør',
          firstName: 'Fornavn',
          lastName: 'Etternavn',
          email: 'E-post',
          companyName: 'Firmanavn',
          privatePerson: 'Privatperson',
          nationalId: 'Fødselsnummer',
          organizationNumber: 'Organisasjonsnummer',
          systemInfo: 'Informasjon om Enersky-tilgangsregistrering',
          accessUrl: 'Tilgangs-URL',
          requestId: 'Forespørsels-ID',
          errorMessage: 'Feilmelding',
          mpidSection: 'Målepunkter (MPID)',
          mpid: 'MPID',
          meterNumber: 'Målernummer',
          address: 'Adresse',
          description: 'Beskrivelse',
          priceArea: 'Prisområde',
          status: 'Status',
          actions: 'Handlinger',
          deleteConfirmMessage:
            'Er du sikker på at du vil slette denne registreringen?',
        },

        buttons: {
          resendLink: 'Send lenke på nytt',
          refreshSubscriptions: 'Oppdater abonnementer',
          readHistoricalData: 'Hent historiske data',
        },

        status: {
          unknown: 'Ukjent status',
        },

        none: 'Ingen',
        unknownError: 'Ukjent feil',
      },
      status: {
        Pending: 'Venter',
        'Contract email sent': 'Signeringslenke sendt',
        'Contract link requested': 'Signeringslenke forespurt',
        Completed: 'Fullført',
        Error: 'Feil',
        Unknown: 'Ukjent status',
      },
    },

    chirpStackKeys: {
      title: 'Importerte nøkkelfiler',
      addButton: 'Importer nøkler',
      columns: {
        fileName: 'Filnavn',
        uploadedAt: 'Lastet opp',
        importedCount: 'Importert antall',
      },
      importFile: 'Importer ChirpStack-nøkkelfil',
      preview: {
        title: 'Forhåndsvisning',
        noRows: 'Ingen forhåndsvisningsrader.',
        close: 'Lukk',
        cancel: 'Avbryt',
        confirm: 'Bekreft import',
      },
      feedback: {
        loadError: 'Kunne ikke laste inn filer',
        previewError: 'Forhåndsvisning mislyktes',
        invalidExcel: 'Ugyldig Excel-fil.',
        missingFile: 'Originalfil mangler, velg på nytt',
        importSuccess: 'Import fullført',
        importError: 'Import mislyktes',
      },
    },

    icMeterData: 'IC-målerdata',
    buildingSensorData: 'Building Sensor Data',
    eosSensorData: 'EOS Sensor Data',
    protocol: 'Kommunikasjonsprotokoll',
  },

  buildings: {
    sidebar: {
      modifyToggle: 'Rediger',
      editBuildingTitle: 'Rediger bygning',
      buildingOverviewTitle: 'Bygningsoversikt',
      editZoneTitle: 'Rediger sone',
      outdoorTemperatureTitle: 'Utetemperatur',
      indoorClimateTitle: 'Inneklima',
      buildingTemperature: 'Byggets temperatur',
      floorTemperature: 'Etasjens temperatur',
      outdoorTempLabel: 'Utendørstemp:',
      electricityPriceLabel: 'Strømpris:',
      energyLabel: 'Energimerke:',
      noData: 'Ingen data',
      aspaTitle: 'ASPA settpunkt',
      zoneFloors: {
        selectFloorLabel: 'Velg soneetasje:',
        selectBuildingFloorLabel: 'Velg bygningens etasje:',
        changeFloor: '- Bytt etasje -',
        addFloor: 'Legg til etasje ',
      },
    },
    aspa: {
      title: 'ASPA innstillinger',
      noPayload: 'Ingen ASPA data funnet for denne bygningen.',
      avgTemp: 'Gjennomsnittstemperatur',
      acrossAllZones: 'På tvers av alle soner',
      highestZoneTemp: 'Høyeste sonetemp.',
      peakZoneReading: 'Høyeste sonemåling',
      lastUpdated: 'Sist oppdatert',
      payloadsReceived: 'datapakker mottatt',
      setpointOverview: 'Settpunktoversikt',
      hourView: '24-timersvisning',
      hourOfDay: 'Time på døgnet',
      dailySetpoint: 'Daglig settpunkt (°C)',
      liveSetpoint: 'Gjeldende settpunkt (°C)',
      avg: 'Snitt',
      peak: 'Topp',
      trends: 'Trender',
      temperature: 'Temperatur',
      humidity: 'Fuktighet',
      noTrendData: 'Ingen trenddata.',
      recommendations: 'Anbefalinger',
      noRecommendations: 'Ingen anbefalinger funnet.',
      actionKeys: {
        cool: 'Kjøling',
        coolingLevel: 'Kjølenivå',
        preCool: 'Forkjøling',
        heat: 'Oppvarming',
        heatingLevel: 'Varmenivå',
        preHeat: 'Forvarming',
      },
      items: 'elementer',
      on: 'På',
      off: 'Av',
      samples: 'målinger',
      trendPeriod: 'Siste 2 timer',
    },
    details: {
      header: 'Bygningsdetaljer',
      form: {
        buildingName: 'Bygningsnavn',
        active: 'Aktiv',
        buildingInformation: 'Bygningsinformasjon',
        buildingType: 'Bygningstype (NS-standard)',
        buildingCategory: 'Bygningskategori',
        constructionYear: 'Byggeår',
        numberOfFloors: 'Antall etasjer',
        netUsableFloorArea: 'Bruksareal (m²)',
        gridRegion: 'Prisområde',
        selectGridRegion: '- Velg område -',
        mix: 'CO₂-miks',
        addressAndGps: 'Adresse & GPS',
        street: 'Gate',
        street2: 'Gate 2',
        postCode: 'Postnummer',
        city: 'By',
        country: 'Land',
        latitude: 'Breddegrad',
        longitude: 'Lengdegrad',
        fetchGps: 'Hent GPS',
        fillStreetCityError:
          'Fyll inn både gate og by for å hente GPS-koordinater.',
        requiredAddressFields: '{fields} må fylles ut før lagring.',
        searchCountry: 'Søk land',
        floorNumber: 'Etasjenummer',
        preferredCurrency: 'Foretrukket valuta',
        climateGoalPercentage: 'Prosentandel av klimamål',
        changeModel: 'Endre bygningsmodell',
        defaultStartingFloor: 'Visningsetasje',
        startingViewHint:
          'Roter, flytt og zoom forhåndsvisningen for å velge visningen bygningen åpner med.',
        matrikkelData: {
          title: 'Matrikkeldata',
          error: 'Kunne ikke hente matrikkeldata',
          errorTitle: 'Feil',
          matrikkelId: 'Matrikkel EnhetsID',
          cadastralNumber: 'Gårdsnummer',
          propertyUnitNumber: 'Bruksnummer',
          sectionNumber: 'Seksjonsnummer',
          unitNumber: 'Bruksenhet',
          leaseholdNumber: 'Festenummer',
          municipalityName: 'Kommunenavn',
          municipalityNumber: 'Kommunenummer',
          success: 'Vellykket',
          successTitle: 'Matrikkeldata hentet',
          fetchMatrikkelData: 'Hent matrikkeldata',
          buildingNumber: 'Bygningsnummer',
          errorMissing: 'Manglende påkrevde adressefelt',
          errorTooMany: 'For mange adresser funnet',
          errorNotFound: 'Ingen adresse funnet',
          unitId: 'Bruksenhets ID',
          noUnitIdFound:
            'Ingen bruksenhet ble funnet på denne adressen. Vennligst sjekk adressen mot seeiedom.no og prøv igjen.',
          sectionTitle: 'Bruksenhet',
          sectionsTitle: 'Seksjon',
          fetchedFromMatrikkel: 'Hentet fra matrikkel',
          overrideButton: 'Overstyr bruksenhet',
          overrideSectionButton: 'Overstyr seksjon',
          addButton: 'Legg til bruksenhet',
          addSectionButton: 'Legg til seksjon',
          manualWarning:
            'Kun nødvendig dersom matrikkeldata mangler eller er feil.',
          buildingType: 'Bygningstype',
        },
      },
      baseline: {
        title: 'Baseline',
        recalcButton: 'Rekalkuler baseline',
        confirmRecalculate: 'Er du sikker på at du vil rekalkulere baseline?',
        success: 'Baseline rekalkulert',
        error: 'Kunne ikke rekalkulere baseline',
        subscriptions: {
          title: 'Elhub-abonnementer',
          loading: 'Laster abonnementer …',
          emptyState: 'Ingen abonnementer funnet. Legg til et nedenfor.',
          actions: {
            unsubscribe: 'Avslutt abonnement',
            subscribe: 'Abonner',
            delete: 'Slett',
            addPlaceholder: 'Skriv inn målepunkt-ID',
            status: {
              waitingApproval:
                'Venter på at kunden godkjenner Elhub-forespørselen',
            },
            validation: {
              onlyDigits: 'Målepunkt-ID må kun inneholde sifre',
              exactLength:
                'Målepunkt-ID må være nøyaktig 18 sifre (f.eks. 707057500042153290)',
              startsWith: 'Målepunkt-ID må starte med 7070575000',
              unique: 'Målepunkt-ID må være unik',
            },
            move: {
              selectTargetBuilding: '- Velg målbygning -',
              moveSelected: 'Flytt valgte',
              instructions:
                'Velg abonnementer ved å krysse av i boksene. Dette kan ta opptil 1 minutt per abonnement.',
              moveSubscriptions: 'Flytt abonnementer',
            },
            feedback: {
              subscribeSuccess: 'Abonnementforespørsel sendt',
              unsubscribeSuccess: 'Abonnement avsluttet',
              deleteSuccess: 'Abonnement slettet',
              subscribeError: 'Kunne ikke sende abonnementforespørsel',
              unsubscribeError: 'Kunne ikke avslutte abonnement',
              deleteError: 'Kunne ikke slette abonnement',
            },
          },
        },
      },
      report: {
        title: 'Rapport',
      },
    },
    model3d: {
      title: '3D modell',
    },
    zoneEdit: {
      title: 'Soneinnstillinger',
      form: {
        zoneName: 'Sonens navn',
        floorNumber: 'Etasjenummer',
        selectCategory: 'Velg en kategori',
        isHeated: 'Oppvarmet sone',
        displayHint: 'Slik vises sonen i 3D visningen.',
        cardSize: 'Kortstørrelse',
        zoneColor: 'Sonefarge',
        devices: {
          availableDevices: 'Tilgjengelige enheter',
          zoneDevices: 'Soneenheter',
          noMatches: 'Ingen enheter samsvarer med søket',
        },
        deleteButton: 'Slett sone',
        deleteZoneDescription: 'Fjerner sonen permanent.',
        deleteZoneConfirm: 'Er du sikker på at du vil slette denne sonen?',
        deleteError: 'Kunne ikke slette sonen',
      },
    },
    technicalRoom: {
      titles: 'Tekniske rom',
      emptyState: 'Ingen tekniske rom funnet.',
      technicalRoomDescription: 'Beskrivelse av det tekniske rommet',
      technicalRoomNamePlaceholder: 'Navn på teknisk rom',
      technicalRoomDevices: 'Enheter i teknisk rom',
      addDevice: 'Legg til enhet',
      technicalRoomDevice: 'Teknisk rom enhet',
      removeDevice: 'Fjern enhet',
      searchPlaceholder: 'Søk teknisk rom',
      technicalRoomOverview: 'Oversikt teknisk rom',
      technicalRoomValue: 'Verdi',
      technicalRoomSeen: 'Sist sett',
      addTechnicalRoom: 'Legg til teknisk rom',
      addDeviceButton: 'Legg til enhet',
      removeDeviceButton: 'Fjern enhet',
      deviceType: 'Enhetstype',
      editorTitle: 'Tekniske rom',
      selectRoom: 'Velg teknisk rom',
      threeDModel: '3D modell',
      replace: 'Bytt',
      selectModel: 'Velg 3D modell',
      modelDefaultsGroup: 'Standardmodeller',
      noModel: 'Ingen 3D modell koblet til dette rommet.',
      bind: 'Koble til',
      rebind: 'Koble til på nytt',
      unbind: 'Koble fra',
      boundTo: 'Koblet til',
      notBound: 'Ikke koblet',
      hide: 'Skjul i 3D',
      show: 'Vis i 3D',
      size: 'Størrelse',
      remove: 'Fjern fra rom',
      pickingHint: 'Klikk modellen for å koble',
      pickingCardHint:
        'Klikk en del av modellen, eller bakgrunnen for å plassere kortet fritt',
      searchDevices: 'Søk enheter…',
      noDevicesAvailable: 'Ingen enheter tilgjengelig',
      noMatches: 'Ingen treff',
      unnamedDevice: 'Uten navn',
      couldNotAddDevice: 'Kunne ikke legge til enhet',
      noReadings24h: 'Ingen avlesninger siste 24 timer',
      dragToReposition: 'Dra for å flytte',
      hideGraph: 'Skjul graf',
      showGraph: 'Vis graf',
      lockedHint: 'Lås opp visningen for å flytte enheter',
      clickToEdit: 'Klikk for å redigere',
      noDescription: 'Ingen beskrivelse',
      noTitle: 'Ingen tittel',
      showCardTitle: 'Korttittel',
      showDeviceName: 'Enhetsnavn',
      cardVisualization: 'Kortvisualisering',
      modelAnimation: 'Modellanimasjon',
      showLine: 'Koblingslinje',
      lineColor: 'Linjefarge',
      resetColor: 'Tilbakestill farge',
      darkTheme: 'Mørkt tema',
      showUnit: 'Måleenhet',
      trendLine: 'Trendlinje',
      trendBars: 'Trendsøyler',
      showUpdated: 'Sist oppdatert',
      visualizationRules: 'Visualiseringsregler',
      ruleDataKey: 'Datanøkkel',
      ruleValue: 'Verdi',
      triggers: 'Utløsere',
      addTrigger: 'Legg til utløser',
      ruleOff: 'Av',
      ruleSlow: 'Sakte',
      ruleFast: 'Rask',
      ruleNoEffect: 'Ingen effekt',
      ruleNoColor: 'Ingen farge',
      ruleReverse: 'Reverser retning',
      particleFlow: 'Partikkelstrøm',
      drawFlow: 'Tegn strøm',
      flowHint: 'Klikk på modellen for å legge til punkter.',
      flowFollowsHint:
        'Partiklene følger utløserne i modellanimasjonen. Er animasjonen av, stopper partiklene.',
      flowColorHint:
        'Klikk på et punkt på strømmen i modellen for å skifte farge derfra.',
      flowColorFromPoint: 'Farge fra valgt punkt',
      flowFollows: 'Følger animasjonen',
      particles: 'Partikler',
      ruleDataKeyRequired: 'Velg en datanøkkel for visualiseringsregelen',
      newTechnicalRoom: 'Nytt teknisk rom',
      roomNamePlaceholder: 'f.eks. Ventilasjon, Fyrrom, Varmepumpe',
      selectBuilding: 'Velg bygning',
      nameRequired: 'Navn er påkrevd',
      buildingRequired: 'Bygning er påkrevd',
      couldNotCreateRoom: 'Kunne ikke opprette rom',
      creating: 'Oppretter',
      loadError: 'Kunne ikke laste teknisk rom',
      textPlaceholder: 'Skriv tekst…',
      noText: 'Ingen tekst',
      linkToRoom: 'Gå til rom',
      noLink: 'Ingen lenke',
      linkHint:
        'I låst visning åpner et klikk på modellen eller kortet dette rommet.',
      confirmRemoveAnnotation:
        'Er du sikker på at du vil fjerne denne teksten fra rommet?',
      dragToReorder: 'Dra for å endre rekkefølge',
      drawFrame: 'Tegn ramme',
      redrawFrame: 'Tegn ramme på nytt',
      frameDrawHint: 'Klikk to hjørner på tegningen',
      noFrame: 'Ingen ramme tegnet',
      frameDrawn: 'Ramme tegnet',
      confirmRemoveFrame:
        'Er du sikker på at du vil fjerne denne rammen fra rommet?',
      confirmRemoveLink:
        'Er du sikker på at du vil fjerne denne lenken fra rommet?',
      annotationsTab: 'Lenker og tekst',
      noAnnotations: 'Ingen lenker eller tekst i dette rommet.',
      placeText: 'Plasser',
      replaceText: 'Plasser på nytt',
      placed: 'Plassert',
      placeTextHint: 'Klikk på tegningen der teksten skal stå',
      placeInfoHint: 'Klikk på tegningen der boblen skal stå',
      confirmRemoveInfo:
        'Er du sikker på at du vil fjerne denne infoboblen fra rommet?',
      ruleAngle: 'Vinkel (grader)',
      infoPanel: 'Alarmer og driftskalender',
      alarmsTab: 'Alarmer',
      calendarsTab: 'Driftskalender',
      noAlarmSystems: 'Ingen alarmsystemer er koblet til dette rommet.',
      noCalendars: 'Ingen driftskalendere er koblet til dette rommet.',
      systemAlarm: 'Systemalarm',
      openInSettings: 'Åpne i innstillinger',
      confirmRemoveDevice:
        'Er du sikker på at du vil fjerne denne enheten fra rommet?',
      attributes: 'Attributter',
      selectAttribute: 'Velg en attributt',
      mappedGroup: 'Tilordnede attributter',
      payloadGroup: 'Rådata',
      mappedNoneText: 'Ingen tilgjengelig,',
      assignHere: 'tilordne her',
      confirmDeleteRoom: 'Er du sikker på at du vil slette {name}?',
      roomDeleted: 'Teknisk rom slettet',
      renameRoom: 'Gi nytt navn til teknisk rom',
      noTechnicalRoomsForType: 'Ingen tekniske rom av denne typen funnet',
      noDevices: 'Ingen enheter i dette tekniske rommet.',
      technicalRoomTypeLabel: 'Teknisk rom-type',
      technicalRoomTypes: {
        type: 'Velg type',
        hvac: 'HVAC',
        technical: 'Teknisk rom',
        electrical: 'Elektrisk',
        plumbing: 'Rørlegger',
        other: 'Annet',
      },
      message: {
        success: 'Teknisk rom opprettet',
        updateSuccess: 'Teknisk rom oppdatert',
        deleteSuccess: 'Teknisk rom slettet',
        error: 'En feil oppstod under behandling av forespørselen',
        deleteConfirm:
          'Er du sikker på at du vil slette dette tekniske rommet?',
      },
    },
  },

  threeD: {
    lockView: 'Lås visning',
    unlockView: 'Lås opp visning',
  },

  buildings3D: {
    header: {
      buildingTab: 'Bygning',
      technicalTab: 'Teknisk',
    },
    footer: {
      home: 'Hjem',
      measure: 'Mål',
      stopMeasure: 'Stopp måling',
      explode: 'Eksploder',
      screenshot: 'Skjermbilde',
      lock: 'Lås',
      unlock: 'Lås opp',
    },
    climate: {
      buildingClimate: 'Inneklima',
      levelsTitle: 'Seksjoner',
      startLabel: 'Start',
      endLabel: 'Slutt',
      apply: 'Bruk',
      avgTemperature: 'Gjennomsnittstemperatur',
      avgHumidity: 'Gjennomsnittlig luftfuktighet',
      avgCo2: 'Gjennomsnittlig CO₂',
      floor: 'Etasje',
      wholeBuilding: 'Hele bygget',
      noTrendData: 'Ingen data',
      fetchData: 'Hent data',
      startMustBeBeforeEnd: 'Start må være før slutt.',
      groundFloor: 'Første etasje',
      weekdaysShort: ['Sø', 'Ma', 'Ti', 'On', 'To', 'Fr', 'Lø'],
    },
    status: {
      good: 'Normalt',
      tooLow: 'For lav',
      tooHigh: 'For høy',
      warning: 'Advarsel',
      poor: 'Dårlig',
    },
    warnings: {
      title: 'Varsler',
      highCo2: 'Høyt CO₂',
      highTemp: 'Høy temperatur',
      lowTemp: 'Lav temperatur',
    },
    alarmLog: {
      title: 'Alarmlogg',
      last24h: 'Siste 24 timer',
      last7d: 'Siste 7 dager',
      last30d: 'Siste 30 dager',
      custom: 'Egendefinert',
      zone: 'Sone',
      activeNow: 'Aktive nå',
      today: 'I dag',
      yesterday: 'I går',
      earlier: 'Tidligere',
      empty: 'Ingen alarmer i dette tidsrommet',
      loadError: 'Kunne ikke laste alarmloggen.',
      unknownZone: 'Ukjent sone',
    },
    deviceLayer: {
      moveDevices: 'Flytt modeller',
      moveHint: 'Dra for å flytte · ⇧ roter · ⌘ høyde',
      moveThisDevice: 'Flytt denne enheten',
      doneMoving: 'Ferdig å flytte',
      changeModel: 'Bytt modell',
      showDataBox: 'Vis databoks',
      hideDataBox: 'Skjul databoks',
      modelSize: 'Modellstørrelse',
      dataSize: 'Datastørrelse',
      hideZones: 'Skjul soner',
      showZones: 'Vis soner',
      hideModels: 'Skjul modeller',
      showModels: 'Vis modeller',
      hideModel: 'Skjul modell',
      showModel: 'Vis modell',
      suggested: 'Foreslått',
      noModelsInCategory: 'Ingen modeller i denne kategorien ennå',
      controllers: 'Kontrollere',
      models: {
        radiatorGlb: 'Radiator',
        panelOvenGlb: 'Panelovn',
        heatpumpGlb: 'Varmepumpe',
        indoorClimateGlb: 'Inneklima',
        icmSensorGlb: 'ICM sensor',
        climateHubGlb: 'Klimahub',
        ventilationOutletGlb: 'Ventilasjonsventil',
        ventilationGrillGlb: 'Ventilasjonsrist',
      },
    },
    zoneControls: {
      leaveFloor: 'Tilbake',
      drawZone: 'Dobbeltklikk for å fullføre',
      clearZones: 'Fjern soner',
      clickFloorToIsolate: 'Klikk på etasje for å isolere',
      select: 'Velg',
      rectangle: 'Rektangel',
      circle: 'Sirkel',
      polygon: 'Polygon',
      zoneNameLabel: 'Sonenavn',
      heightLabel: 'Høyde',
      editVertexHint:
        'Dra i punktene for å endre, dobbeltklikk punkt for å legge til flere',
      unnamedZone: 'Sone uten navn',
      zoneNameRequired: 'Sonenavn er påkrevd',
      zonesMissingData: 'Soner mangler 3D data',
      zonesMissingDataTitle: 'Soner mangler 3D modelldata:',
      floorLabel: 'Etasje',
      zoneCreated: 'Sone opprettet',
      zoneUpdated: 'Sone oppdatert',
      zoneDeleted: 'Sone slettet',
      failedToCreateZone: 'Kunne ikke opprette sone',
      failedToUpdateZone: 'Kunne ikke oppdatere sone',
      failedToDeleteZone: 'Kunne ikke slette sone',
      confirmDeleteZoneTitle: 'Slett sone?',
      confirmDeleteZoneMessage:
        'Er du sikker på at du vil slette denne sonen? Dette kan ikke angres.',
    },
  },

  deviceAlarms: {
    updatedSuccess: 'Enhetsalarm oppdatert',
    createdSuccess: 'Enhetsalarm opprettet',
    deletedSuccess: 'Enhetsalarm slettet',

    editTitle: 'Rediger enhetsalarm',
    createTitle: 'Opprett enhetsalarm',
    title: 'Enhetsalarmer',
    manageAlarmsForDevice: 'Administrer alarmer for {device}',
    recipients: 'Mottakerliste',

    alarmDetails: 'Alarmdetaljer',
    deviceSelection: 'Enhetsvalg',
    alarmConditions: 'Alarmbetingelser',
    condition: 'Betingelse',
    conditions: 'Betingelser',
    noConditions: 'Ingen betingelser lagt til ennå.',
    noConditionsSaveError: 'Minst en betingelse må legges til',

    name: 'Navn',
    description: 'Beskrivelse',
    alarmSystem: 'Alarmsystem',
    selectDevice: 'Velg enhet',
    dataKey: 'Datanøkkel',
    selectKey: 'Velg nøkkel',
    level: 'Nivå',
    operator: 'Operator',
    value: 'Verdi',
    duration: 'Varighet (min)',
    message: 'Melding',
    active: 'Aktiv',

    greaterThan: 'Større enn',
    lessThan: 'Mindre enn',
    equal: 'Lik',
    notEqual: 'Ikke lik',
    missing: 'Mangler',
    unchanged: 'Uendret',

    addTrigger: 'Legg til utløser',
    addCondition: 'Legg til betingelse',
    triggers: 'Utløsere',

    standardDevices: 'Standard enheter',
    eosDevices: 'EOS-enheter',
    noDataKeys: 'Ingen datanøkler tilgjengelig for denne enheten.',

    noAlarmSystems: 'Ingen alarmsystemer tilgjengelig.',
    pleaseCreateFirst: 'Vennligst opprett en først',
    selectDeviceFirst:
      'Vennligst velg en enhet først for å konfigurere alarmbetingelser.',
    messagePlaceholder: 'Varselmelding som skal vises...',
    confirmDelete: 'Er du sikker på at du vil slette denne enhetsalarmen?',
    list: {
      new: 'Ny',
      search: 'Søk...',
      empty: 'Ingen enhetsalarmer funnet',
    },
    deleteAlarmTitle: 'Slett alarm',
    deleteAlarmDescription: 'Denne handlingen kan ikke angres.',
  },

  settings: {
    areas: {
      home: 'Hjem',
      vendor: 'Generelt',
      devices: 'Enheter',
      eos_devices: 'EOS-enheter',
      categories: 'Kategorier',
      users: 'Brukere',
      themes: 'Temaer',
      integrationOverview: 'API-integrasjoner',
      fileCloud: 'Filsky',
      energyPrices: 'Energipriser',
      alarms: 'Alarmer',
      alarmSystemDescription:
        'Administrer og tilpass alarmsystemer med skreddersydde varsler og overvåking av hjertefrekvens for å holde deg informert om kritiske hendelser og sikre rettidige reaksjoner.',
      baseline: 'Baseline',
      technicalRoomOverview: 'Teknisk rom',
      aspaSetup: 'ASPA oppsett',
      controlStrategy: 'Styringsstrategi',
      operatingCalendar: 'Driftskalendere',
      setpoint: 'Settpunkter',
    },

    home: {
      title: 'Firmadashbord',
      tagline:
        'Administrer firmainnstillinger, brukere, enheter og temaer på ett sted',
    },

    setpoint: {
      title: 'Settpunkter',
      backToList: 'Alle settpunkter',
      description:
        'Grenseverdier for temperatur, fuktighet og CO₂ per bygning og sone.',
      searchPlaceholder: 'Søk i settpunkter …',
      emptyState: 'Ingen settpunkter enda.',
      addButton: 'Nytt settpunkt',
      loadError: 'Kunne ikke hente settpunktene.',
      zonesLoadError: 'Kunne ikke hente sonene.',
      saveError: 'Kunne ikke lagre settpunktet.',
      deleteError: 'Kunne ikke slette settpunktet.',
      requiredError: 'Disse feltene må fylles ut:',
      deleteConfirmTitle: 'Slett settpunkt',
      deleteConfirmMessage:
        'Er du sikker på at du vil slette dette settpunktet? Dette kan ikke angres.',
      editTitle: 'Rediger settpunkt',
      newTitle: 'Nytt settpunkt',
      editDescription: 'Grenseverdiene gjelder for sonene du velger.',
      saveButton: 'Lagre settpunkt',
      openSetpoint: 'Åpne settpunktet',
      buildingSection: 'Bygning',
      building: 'Bygning',
      name: 'Navn',
      namePlaceholder: 'F.eks. Kontor standard',
      zonesSection: 'Soner',
      selectAll: 'Velg alle',
      clearAll: 'Fjern alle',
      noZones: 'Velg en bygning for å se sonene.',
      allZonesTaken: 'Alle soner i denne bygningen har allerede et settpunkt.',
      zonesTakenError:
        'En eller flere soner tilhører allerede et annet settpunkt.',
      noZonesSelected: 'Ingen soner valgt',
      floor: 'Etasje',
      noFloor: '—',
      limitsSection: 'Grenseverdier',
      columns: {
        name: 'Navn',
        building: 'Bygning',
        zones: 'Soner',
        inOperation: 'I drift',
        outsideOperation: 'Utenfor drift',
        interval: 'Sjekkintervall',
      },
    },
    operatingCalendar: {
      backToList: 'Alle driftskalendere',
      title: 'Driftskalendere',
      description:
        'Normal driftstid per bygg og sone, med ekstraordinær drift på toppen.',
      searchPlaceholder: 'Søk i driftskalendere …',
      emptyState: 'Ingen driftskalendere enda.',
      addButton: 'Ny driftskalender',
      running: 'Løpende, uten sluttdato',
      openCalendar: 'Åpne kalenderen',
      zonesLoadError: 'Kunne ikke hente sonene.',
      loadError: 'Kunne ikke hente driftskalenderne.',
      saveError: 'Kunne ikke lagre driftskalenderen.',
      deleteError: 'Kunne ikke slette driftskalenderen.',
      requiredError: 'Disse feltene må fylles ut:',
      deleteConfirmTitle: 'Slett driftskalender',
      deleteConfirmMessage:
        'Er du sikker på at du vil slette denne driftskalenderen? Dette kan ikke angres.',
      editTitle: 'Angi normaldrift',
      editDescription: 'Fast ukentlig driftstid for de valgte sonene.',
      saveButton: 'Lagre normaldrift',
      buildingSection: 'Bygning',
      building: 'Bygning',
      zonesSection: 'Soner',
      selectAll: 'Velg alle',
      clearAll: 'Fjern alle',
      noZonesSelected: 'Ingen soner valgt',
      zonesTakenError:
        'Én eller flere soner ligger allerede i en annen driftskalender.',
      allZonesTaken:
        'Alle soner i denne bygningen ligger allerede i en driftskalender.',
      noZones: 'Velg en bygning for å se sonene.',
      floor: 'Plan',
      noFloor: 'Uten plan',
      validitySection: 'Navn og gyldighet',
      name: 'Navn',
      validFrom: 'Gjelder fra',
      validTo: 'Gjelder til',
      weekPlanSection: 'Ukeplan',
      copyMonday: 'Kopier mandag til alle hverdager',
      noOperation: 'Ingen drift',
      weeklyTotal: 'Sum per uke',
      from: 'Fra',
      to: 'Til',
      calendarTitle: 'Driftskalender',
      week: 'Uke',
      previousWeek: 'Forrige uke',
      nextWeek: 'Neste uke',
      today: 'I dag',
      editNormal: 'Normaldrift',
      addOverride: 'Legg inn ekstraordinær drift',
      thisWeek: 'Denne uken',
      operatingHours: 'Driftstimer',
      extraordinaryDays: 'Ekstraordinære dager',
      upcomingOverrides: 'Kommende ekstraordinær drift',
      noOverrides: 'Ingenting planlagt.',
      fixedOperation: 'Fast drift',
      publicHoliday: 'Rød dag',
      extraordinary: 'Ekstraordinær drift',
      closed: 'Stengt',
      opensAt: 'Åpner',
      closesAt: 'Stenger',
      inOperation: 'I drift',
      outOfOperation: 'Ute av drift',
      allDay: 'Hele dagen',
      reason: 'Årsak',
      overrideSaveError: 'Kunne ikke lagre den ekstraordinære driften.',
      overrideDeleteError: 'Kunne ikke slette.',
      columns: {
        name: 'Navn',
        building: 'Bygning',
        zones: 'Soner',
        validity: 'Gyldighet',
        hoursPerWeek: 'Timer/uke',
      },
      weekdays: {
        mon: 'Man',
        tue: 'Tir',
        wed: 'Ons',
        thu: 'Tor',
        fri: 'Fre',
        sat: 'Lør',
        sun: 'Søn',
      },
    },
    controlStrategy: {
      list: {
        header: 'Styringsstrategier',
        addButton: 'Legg til styringsstrategi',
        emptyState: 'Ingen styringsstrategier funnet.',
        searchPlaceholder: 'Søk etter bygg...',
      },
      feedback: {
        saveSuccess: 'Styringsstrategi lagret',
        saveError: 'En feil oppstod under lagring av styringsstrategien',
        buildingRequired: 'Bygning er påkrevd',
        bothHoursRequired: 'Både driftstid start og slutt må fylles ut',
        startBeforeEnd: 'Driftstid start må være før driftstid slutt',
        deleteSuccess: 'Styringsstrategi slettet',
        deleteError: 'En feil oppstod under sletting av styringsstrategien',
        confirmDeleteTitle: 'Slett styringsstrategi',
        confirmDeleteMessage:
          'Er du sikker på at du vil slette denne styringsstrategien? Dette kan ikke angres.',
      },
      schedule: 'Driftstid',
      timezone: 'Tidssone',
      startHour: 'Driftstid start',
      endHour: 'Driftstid slutt',
      actions: 'Handlinger',
      coolingLevel: 'Kjølenivå',
      heatingLevel: 'Varmenivå',
      businessHoursControl: 'Styring i driftstid',
      afterHoursControl: 'Styring utenfor driftstid',
      controlOutsideBusinessHours: 'Styring utenfor driftstid',
      tempMin: 'Temp min (°C)',
      tempMax: 'Temp maks (°C)',
      co2Min: 'CO₂ min (ppm)',
      co2Max: 'CO₂ maks (ppm)',
      actionLabels: {
        cool: 'Kjøl',
        heat: 'Varm',
        preCool: 'Forhåndskjøl',
        preHeat: 'Forhåndsvarm',
        ventilate: 'Ventiler',
        dehumidify: 'Avfukting',
      },
      closed: 'Stengt',
      afterHoursActions: 'Handlinger utenfor driftstid',
    },

    baseline: {
      updated: 'Oppdatert',
      title: 'Baseline',
      searchPlaceholder: 'Søk etter baseline...',
      addButtonLabel: 'Lag ny baseline',
      confirmDeleteTitle: 'Slett baseline',
      confirmDeleteMessage: 'Er du sikker på at du vil slette denne baselinen?',
      noBaselines: 'Ingen baselines funnet. Opprett en ny baseline.',
      createNewBaselineConfirm:
        'Lag ny Baseline? Dette vil overskrive eksisterende.',
      editBaseline: 'Rediger Baseline for',
      calculateBaseline: 'Lag Baseline',
      baselineChart: 'Baseline Graf',
      monthsCovered: 'Måneder i baseline',
      excludeMonths: 'Ekskluder måneder',
      pendingChanges:
        'Ulagrede endringer, klikk Lagre for å oppdatere baseline',
      clickMonthsToExclude:
        'Klikk på måneder for å ekskludere dem fra Baseline. Oransje måneder har 20 % eller mer avvik fra Baseline.',
      year: 'År',
      month: 'Måned',
      energyType: 'Energitype',
      monthlySummary: 'Månedlig sammendrag',
      weeklySummary: 'Ukentlig sammendrag',
      week: 'Uke',
      summary: 'Sammendrag',
      energyTypes: {
        electricity: 'Elektrisitet',
        districtHeating: 'Fjernvarme',
        fuel: 'Fossilt brensel',
      },
      excluded: 'Ekskludert fra baseline',
      overBaseline: 'Over baseline',
      underBaseline: 'Under baseline',
      included: 'Inkludert i baseline',
      activeLabel: 'Aktiv',
      inactiveLabel: 'Inaktiv',
      createdAt: 'Opprettet',
      lockTooltip: {
        locked: 'Låst — klikk for å tillate endringer',
        unlocked: 'Lås for å forhindre endringer',
      },
      description: 'Opprett og konfigurer baseliner',
      backButtonLabel: 'Tilbake til baseliner',
    },

    aspaSetup: {
      list: {
        header: 'ASPA oppsett',
        addButton: 'Legg til ASPA oppsett',
        emptyState: 'Ingen ASPA oppsett funnet.',
        searchPlaceholder: 'Søk...',
      },
      edit: {
        name: 'ASPA oppsett navn',
        units: 'Enheter',
        addUnit: 'Legg til enhet',
        unitName: 'Enhetsnavn',
        setpoints: 'Settpunkter',
        zones: 'Soner',
        removeUnit: 'Fjern enhet',
        copyMondayToWeekdays: 'Kopier mandag til ukedager',
        copyMondayToAllDays: 'Kopier mandag til alle dager',
      },
      feedback: {
        deleteSuccess: 'ASPA oppsett slettet',
        deleteError: 'En feil oppstod under sletting av ASPA oppsett',
        updateSuccess: 'ASPA oppsett oppdatert',
        updateError: 'En feil oppstod under oppdatering av ASPA oppsett',
        createSuccess: 'ASPA oppsett opprettet',
        createError: 'En feil oppstod under opprettelse av ASPA oppsett',
        saveError: 'En feil oppstod under lagring av ASPA oppsett',
      },
    },

    energyPrices: {
      list: {
        add: 'Legg til energipris',
        header: 'Innstillinger for energipriser',
        emptyState: 'Ingen energiprisinnstillinger funnet.',
        searchPlaceholder: 'Søk i energiprisinnstillinger...',
      },

      name: 'Navn',
      notes: 'Notater',
      building: 'Bygg',
      selectBuilding: 'Velg bygg',
      validFrom: 'Gyldig fra',
      validTo: 'Gyldig til',
      ongoing: 'Løpende',
      notSpecified: 'Ikke Angitt',
      electricityDetails: 'Elektrisitetsdetaljer',
      priceModel: 'Prismodell',
      fixed: 'Fastpris',
      spotMarkup: 'Spot + påslag',
      fixedPricePerKWh: 'Fastpris per kWh',
      spotMarkupPerKWh: 'Påslag per kWh',

      supplierMonthlyFee: 'Leverandør månedsgebyr',
      co2Emissions: 'CO₂-utslipp (gCO₂/kWh)',

      gridTariffs: 'Nettariffer',
      gridTariff: 'Nettleie',
      fixedMonthly: 'Fast månedsgebyr',
      energyPerKWh: 'Energi per kWh',
      demandPerKWMonthly: 'Effektledd per kW per måned',
      consumptionTaxPerKWh: 'Forbruksavgift per kWh',

      energySources: 'Energikilder',
      addEnergySources: 'Legg til energikilder',
      energySource: 'Informasjon om energikilde',
      sourceName: 'Kildenavn',
      electricity: 'Levert elektrisitet',
      electricityPrice: 'Strømpris',
      electricityProduced: 'Produsert elektrisitet',
      electricityExported: 'Eksportert elektrisitet',

      districtHeating: 'Fjernvarme',
      districtHeatingSource: 'Fjernvarmens energikilde',
      districtHeatingPrice: 'Fjernvarmepris',
      districtHeatingEnergyPrice: 'Energipris (kr/kWh)',
      districtHeatingDemandPerKWMonthly: 'Høyeste målte effekt (kr/kW/mnd)',

      fuelSources: 'Energikilder',
      fuelSource: 'Informasjon om energikilde',
      fuelType: 'Energikilde',

      propane: 'Propan',
      fuelOilDiesel: 'Fyringsolje / Diesel',
      lng: 'Naturgass (LNG)',
      kerosene: 'Parafin',
      pelletsBricks: 'Pellets / Briketter',
      biodiesel: 'Biodiesel',
      biogas: 'Biogass',
      other: 'Annet',

      consumptionUnit: 'Forbruksenhet',
      kg: 'kg',
      liter: 'liter',
      unitPrice: 'Enhetspris',
      consumption: 'Forbruk',
      conversionFactorToKWh: 'Konverteringsfaktor til kWh',

      periodLabel: 'Periode',
      periodLabelPlural: 'Perioder',
      noPeriodsDefined: 'Ingen perioder valgt.',
      periodName: 'Periodenavn',
      addPeriod: 'Legg til periode',
      removePeriod: 'Fjern periode',
      removePeriodConfirmation:
        'Er du sikker på at du vil fjerne denne perioden?',
      overlappingPeriodsError:
        'Periodene "{p1}" og "{p2}" overlapper.\n\n' +
        'Du kan ikke ha to perioder som gjelder samtidig (samme måneder og overlappende tid). ' +
        'Juster måneder eller aktive timer før du lagrer.',
      confirmRemovePeriod: 'Er du sikker på at du vil fjerne perioden?',
      mixedMonthsError:
        'Du kan ikke blande spesifikke måneder med "alle måneder" (tomme måneder) på tvers av perioder.\n\n' +
        'Disse periodene må velge måneder: {periods}\n\n' +
        'Tips: Velg måneder for alle perioder, eller la måneder stå tomt for alle perioder.',
      generalInformation: 'Generell informasjon',
      activeMonths: 'Aktive måneder (alle hvis tom)',
      activeBetween: 'Aktiv tid (hele døgnet hvis tom)',
      chosenMonths: 'Aktive måneder',
      activeHours: 'Aktive tider',
      allYear: 'Hele året',
      allDay: 'Hele døgnet',
      addAdditionalTimer: 'Legg til nytt tidsintervall',
      startTime: 'Starttid ',
      endTime: 'Sluttid ',
      timeRangeInvalid: 'Sluttid må være etter starttid',
      timeRangesOverlap: 'Perioder kan ikke overlappe',
      timeRangeEqual: 'Start- og sluttid kan ikke være like',
      co2Source: 'Fjernvarmens energitype',
      co2Array: [
        'Elektrisitet',
        'Avfall',
        'Lett fyringsolje',
        'Tung fyringsolje',
        'Propan',
        'Naturgass (LNG)',
        'Bio primær trebrensel',
        'Bio sekundær trebrensel',
        'RT-flis',
        'Pellets, briketter og pulver',
        'Bio-olje',
        'Varmepumpe',
      ],

      fixedFees: 'Faste avgifter',
      substationFee: 'Kundesentralavgift (per måned)',
      reactiveEffect: 'Avgift for reaktiv effekt',

      connectedDevices: 'Tilkoblede enheter',
      noConnectedDevices: 'Ingen tilkoblede enheter',
      deletedDevice: 'Slettet',
      removeSource: 'Fjern kilde',
      noLinkedDevices: 'Ingen tilkoblede enheter',
      linked: 'Tilkoblede enheter',
      unlinkDeviceMessage: 'Er du sikker på at du vil fjerne denne enheten?',

      linkSourceTitle: 'Koble energikilde til EOS-enhet',
      linkSource: 'Koble energikilde til EOS-enheter',
      linkSourceDescription:
        'Velg hvilke EOS-enheter som er koblet til denne energikilden.',

      removeElectricitySourceConfirmation:
        'Er du sikker på at du vil fjerne strømkilden ',
      removeDistrictHeatingSourceConfirmation:
        'Er du sikker på at du vil fjerne fjernvarmekilden ',
      removeFuelSourceConfirmation:
        'Er du sikker på at du vil fjerne energikilden ',
    },

    dashboardItems: {
      themes: {
        title: 'Temaer',
        description: 'Opprett og administrer fargetemaer for applikasjonen',
        linkText: 'Vis temaer',
      },
      users: {
        title: 'Brukere',
        description: 'Administrer brukerkontoer og tillatelser',
        linkText: 'Vis brukere',
      },
      eosDevices: {
        title: 'EOS-enheter',
        description: 'Overvåk og administrer energiovervåkingssensorer',
        linkText: 'Vis EOS-enheter',
      },
      settings: {
        title: 'Innstillinger',
        description: 'Konfigurer systemomfattende applikasjonsinnstillinger',
        linkText: 'Vis innstillinger',
      },
      devices: {
        title: 'Enheter',
        description: 'Konfigurer og overvåk tilkoblede enheter',
        linkText: 'Vis enheter',
      },
      fileCloud: {
        title: 'Filsky',
        description: 'Lagre, organiser og del filer i hele organisasjonen',
        linkText: 'Vis filer',
      },
      integration: {
        title: 'API-integrasjoner',
        description: 'Konfigurer og administrer API-tilkoblinger',
        linkText: 'Vis integrasjoner',
      },
      categories: {
        title: 'Kategorier',
        description: 'Opprett og administrer enhetskategorier',
        linkText: 'Vis kategorier',
      },
    },

    topics: {
      addButton: 'Legg til emne',
      eosName: 'EOS-navn',
      sensorTag: 'Sensortagg',
      sensorTagRequired: 'Sensortagg er påkrevd',
      sensorTagTooShort: 'Sensortagg må være minst 3 tegn',
      assignedTo: 'Brukt av',
      aggregator: {
        title: 'Aggregator',
        sum: 'Sum',
        average: 'Gjennomsnitt',
        max: 'Maks',
        min: 'Min',
        cumulative: 'Kumulativ',
        differential: 'Differensiell',
        last: 'Siste',
        none: 'Ingen',
      },
      scale: 'Skala',
      decimals: 'Desimaler',
      units: 'Enheter',
      removeButton: 'Fjern',
      deleteTopic: 'Slett emne',
      confirmDelete: 'Er du sikker på at du vil slette dette emnet?',
    },

    devices: {
      installNetmoreButton: 'Installer Netmore-enhet',
      gatewayInstaller: 'Lag ny Netmore Gateway',
      gatewayEUI: 'Gateway EUI',
      installChirpStackButton: 'Installer ChirpStack-enhet',
      serialNumber: 'Serienummer',
      bulkSerialsLabel: 'Serienumre (kommaseparert eller ny linje)',
      ui: {
        singleModeTitle: 'Enkel enhet',
        bulkModeTitle: 'Masseinstallasjon',
        bulkNameHintLine1: 'Navn er tomt -> serienumre brukes som navn',
        bulkNameHintLine2: 'Navn er satt -> alle enheter bruker samme navn',
      },
      visualToggle: {
        visualToggleDevice: 'Visuelle enheter',
        visualToggleBuilding: 'Bygning',
        visualToggleDelimiter: 'Delimiter',
        visualToggleDataKey: 'Data Nøkkel',
        visualToggleProperty: 'kjennetegn',
        visualTogglePropertyId: 'kjennetegn-ID',
        visualToggleValue: 'Verdi',
        visualToggleColor: 'Farge',
        visualToggleTriggers: 'Triggere',
        visualToggleAddTrigger: 'Legg til trigger',
        visualToggleRemove: 'Fjern trigger',
        visualToggleSelectBuilding: 'Velg bygg',
        visualToggleSelectValue: 'Velg verdi',
        visualToggleDev: 'Enhet',
        visualToggleOverview: 'Visuell enhet oversikt',
        visualToggleAdd: 'Legg til Visuell enhet',
        visualToggleGlobalModels: 'Globale 3D Modeller',
        visualToggleDelete: 'Slett Visuell enhet',
        visualToggleNoDevices: 'Ingen Visuelle enheter funnet.',
        visualToggleSearchPlaceholder: 'Søk Visuelle enheter...',
        visualToggleName: 'Navn',
        visualToggleTechnicalRoom: 'Teknisk rom',
        visualToggleSelectRoom: 'Velg et teknisk rom',
        visualToggleBuildingRequired: 'Bygg er påkrevd',
        visualToggleTechnicalRoomRequired: 'Teknisk rom er påkrevd',
        visualToggleDeviceRequired: 'Enhet er påkrevd',
        visualtoggleAxes: {
          xAxis: 'Rotasjon X',
          yAxis: 'Rotasjon Y',
          zAxis: 'Rotasjon Z',
          off: 'Av',
          half: 'Halv',
          full: 'Full',
          none: 'Ingen',
        },
        feedback: {
          visualToggleDeleteConfirm:
            'Er du sikker på at du vil slette denne Visuelle enheten?',
          visualToggleDeleteSuccess: 'Visuell enhet slettet',
          visualToggleDeleteError:
            'Det oppstod en feil under sletting av Visuell enheten',
          visualToggleDataKey: 'Manglende data nøkkel',
          visualToggleTrigger: 'Manglende trigger',
          visualToggleProperty: 'Egenskap er påkrevd.',
          visualToggleValue: 'Verdi er påkrevd.',
          visualToggleUpdated: 'Visuell enhet oppdatert',
          visualToggleCreated: 'Visuell enhet opprettet',
          visualToggleSaveError:
            'Det oppstod en feil under lagring av Visuell enheten',
        },
      },
      deviceControls: {
        title: 'Enhetskontroller',
        send: 'Send',
        updateSuccessMessage: 'Setpunkt oppdatert',
        updateSuccessTitle: 'Suksess',
        updateErrorTitle: 'Feil',
        updateErrorMessage: 'Kunne ikke oppdatere setpunkt',
        hideAdvanced: 'Skjul avanserte innstillinger',
        showAdvanced: 'Vis avanserte innstillinger ({count} enheter)',
        current: 'Verdi',
        range: 'Fra',
        duration: 'Varighet (timer)',
        durationHelp: 'Settpunktet går tilbake til planen etter dette',
        comment: 'Kommentar',
        commentPlaceholder: 'Hvorfor overstyres dette?',
        notLogged: 'Settpunktet er satt, men overstyringen ble ikke logget',
      },
      list: {
        header: 'Enhetsadministrasjon',
        addButton: 'Legg til enhet',
        emptyState: 'Ingen enheter funnet.',
        searchPlaceholder: 'Søk i enheter...',
        backButton: 'Tilbake til enheter',
      },

      validation: {
        nameRequired: 'Enhetsnavn er påkrevd',
        sensorTagMissing: 'Sensor-tag mangler for emne {{index}}.',
        sensorTagTooShort:
          'Sensor-tag for emne {{index}} må være minst 3 tegn lang.',
      },
      feedback: {
        updateSuccess: 'Enhet oppdatert',
        updateError: 'En feil oppstod under oppdatering av enheten',
        createSuccess: 'Enhet opprettet',
        installSuccess: 'Enheten ble installert',
        createError: 'En feil oppstod under oppretting av enheten',
        duplicateDevice: 'Enhet med dette serienummeret finnes allerede.',
        saveError: 'En feil oppstod ved lagring av enheten',
        missingAttributes: 'Noen obligatoriske attributter mangler for enheten',
        validationError: 'Valideringsfeil',
        serviceUnavailable:
          'Tjenesten er midlertidig utilgjengelig. Vennligst prøv igjen senere.',
        bulkInstallSummary:
          'Installert: {installed}. Duplikater: {duplicates}. Mislykket: {failed}.',
      },
    },
    eosDevices: {
      energyCategories: {
        electricityGrid: 'Strøm (nett)',
        electricityGridExport: 'Eksportert strøm (nett)',
        districtHeating: 'Fjernvarme',
        districtCooling: 'Fjernkjøling',
        fossilFuels: 'Fossilt brensel',
        biofuels: 'Biobrensel',
        solarPV: 'Solceller',
        solarThermal: 'Solvarme',
        otherRenewables: 'Annen fornybar energi (vind, geotermisk)',
        wasteHeat: 'Spillvarme',
      },
      list: {
        header: 'EOS-enheter',
        addButton: 'Legg til EOS-enhet',
        emptyState: 'Ingen EOS-enheter funnet.',
        searchPlaceholder: 'Søk i EOS-enheter...',
        backButton: 'Tilbake til EOS-enheter',
      },
      validation: {
        sensorTagMissing: 'Sensor-tag mangler for emne {{index}}.',
        sensorTagTooShort:
          'Sensor-tag for emne {{index}} må være minst 3 tegn lang.',
      },
      feedback: {
        updateSuccess: 'Enhet oppdatert',
        updateError: 'En feil oppstod under oppdatering av enheten',
        createSuccess: 'Enhet opprettet',
        createError: 'En feil oppstod under oppretting av enheten',
        saveError: 'En feil oppstod ved lagring av enheten',
      },
    },

    editDevice: {
      newTitle: 'Ny enhet',
      deviceName: 'Enhetsnavn',
      deviceDescription: 'Enhetsbeskrivelse',
      deviceProfile: 'Enhetsprofil',
      selectDeviceProfile: '- Velg enhetsprofil',
      setpointRange: 'Settpunktområde',
      setpointRangeInfo:
        'Angi øvre og nedre settpunktverdi for sensor-taggen, samt steglengden som skal tas mellom settpunktene.',
      minSetpoint: 'Nedre settpunkt',
      maxSetpoint: 'Øvre settpunkt',
      stepSize: 'Steglengde',
      controlMode: {
        label: 'Kontrollmodus',
        info: 'Bestemmer hvordan enheten reguleres når styring utløses.\nSteg: Justerer settpunktet gradvis opp/ned med steglengden per kjøring, innenfor min/maks.\nBinær: Hopper direkte til maks (mer varme/ventilasjon) eller min (mindre). Av/på-styring.\nTidsplan: Følger kun åpningstidene — maks innenfor, min utenfor. Ignorerer ASPA-handlinger.\nSettpunkt: Skriver ønsket settpunkt direkte, begrenset til min/maks. Oppdaterer bare ved avvik over ±0,1.',
        step: 'Steg',
        binary: 'Binær',
        schedule: 'Tidsplan',
        setpoint: 'Settpunkt',
      },
      operatingHoursOnly: 'Styres kun innenfor driftstid',
      dynamicSetpoints: {
        label: 'Dynamiske settpunkter',
        info: 'Dynamiske settpunkter lar enheten overstyre settpunktområdet sitt basert på andre sensorverdier. Når sensorverdien i sensortaggen oppfyller betingelsen (operator + terskel), brukes nedre settpunkt, øvre settpunkt og steglengde fra raden i stedet for enhetens vanlige settpunktområde.\nSensortagg: sensortaggen som overvåkes (f.eks. pådrag på kjølebatteri).\nOperator/terskel: betingelsen som må være oppfylt for at overstyringen skal være aktiv.\nNedre/øvre settpunkt og steglengde: settpunktområdet som gjelder så lenge betingelsen er oppfylt.',
        add: 'Legg til dynamisk settpunkt',
        deleteTitle: 'Fjern dynamisk settpunkt',
        confirmDelete:
          'Er du sikker på at du vil fjerne dette dynamiske settpunktet?',
        operator: 'Operator',
        threshold: 'Terskel',
        validationError:
          'Alle feltene må fylles ut for å legge til et dynamisk settpunkt.',
        fieldRequired: 'Påkrevd',
      },
      controllerSettings: 'Kontrollerinnstillinger',
      status: {
        active: 'Aktiv',
        displayInZone: 'Vis i sone',
      },
      display: 'Visning',
      icon: 'Ikon',
      deviceType: {
        label: 'Enhetstype',
        selectDefault: '- Velg enhetstype -',
        sensor: 'Sensor',
        controller: 'Kontroller',
      },
      dataReceiver: {
        label: 'Datamottaker',
        selectDefault: '- Velg datamottaker',
        info: 'Angi hvilken mottaker som skal motta styringsverdier for denne enheten.',
      },
      deviceCategory: {
        label: 'Enhetskategori',
        selectDefault: 'Velg en kategori',
      },
      valueMap: 'Verdikartlegging til tekst (valgfritt)',
      setValueMapping: 'Angi verdikartlegging',
      mappedAttribute: {
        label: 'Kartlagt attributt',
        attribute: 'Attributt',
        numberValue: 'Nummer',
        textValue: 'Tekst',
        duplicateValueMapping: 'Denne verdien finnes allerede!',
        cancelEditValueMapping: 'Avbryt',
        removeValueMapping: 'Fjern',
        editValueMapping: 'Rediger',
        deleteTitle: 'Slett verdikartlegging',
        confirmDeleteValueMapping:
          'Er du sikker på at du vil slette denne verdikartleggingen?',
        confirmDeleteMappedAttributeTitle: 'Slett kartlagt attributt',
        confirmDeleteMappedAttribute:
          'Er du sikker på at du vil slette dette kartlagte attributtet?',
      },
      topics: 'Emner',
      inspectDevice: 'Inspiser enhet',
      deleteButton: {
        deleting: 'Sletter …',
        label: 'Slett enhet',
      },
      confirmDelete: 'Er du sikker på at du vil slette denne enheten?',
      title: 'Rediger enhet',
    },

    editEosDevice: {
      title: 'Rediger EOS-enhet',
      newTitle: 'Ny EOS-enhet',
      deviceName: 'Enhetsnavn',
      topics: 'Emner',
      deviceDescription: 'Enhetsbeskrivelse',
      active: 'Aktiv',
      producingPower: 'Produserer energi',
      includeInBaseline: 'Inkluder i baseline',
      deviceSettings: 'Enhetsinnstillinger',
      energyCategory: { label: 'Energikategori' },
      provider: {
        label: 'Leverandør',
        required: 'Leverandør er påkrevd for fjernvarme',
        options: {
          hafslund: 'Hafslund (Celsio)',
          luneraEnergi: 'Lunera Energi',
        },
      },
      building: 'Bygning',
      allBuildings: 'Alle bygninger',
      sensorTypes: {
        HEAT: 'Varme',
        LIGHT: 'Lys',
        HVAC: 'HVAC',
        PRODUCTION: 'Produksjon',
        OFFICE: 'Kontor',
        OTHER: 'Annet',
      },
      icon: 'Ikon',
      deviceType: {
        label: 'Enhetstype',
        selectDefault: '- Velg enhetstype -',
        eosSensor: 'EOS-sensor',
        eosSource: 'EOS-kilde',
      },
      sensorConfiguration: 'Sensorkonfigurasjon',
      deviceCategory: {
        label: 'Enhetskategori',
        selectDefault: 'Velg en kategori',
      },
      sources: 'Kilder',
      inspectDevice: 'Inspiser enhet',
      deleteButton: {
        deleting: 'Sletter …',
        label: 'Slett EOS-enhet',
      },
      confirmDelete: 'Er du sikker på at du vil slette denne enheten?',
    },

    categories: {
      list: {
        header: 'Kategorier',
        addButton: 'Legg til kategori',
        emptyState: 'Ingen kategorier funnet.',
        searchPlaceholder: 'Søk i kategorier...',
        backButton: 'Tilbake til kategorier',
      },
      feedback: {
        updateSuccess: 'Kategori oppdatert',
        updateError: 'Feil under oppdatering av kategori',
        createSuccess: 'Kategori opprettet',
        createError: 'Feil under oppretting av kategori',
        saveError: 'Feil under lagring av kategori',
      },
    },
    editCategory: {
      parentCategory: 'Overordnet kategori',
      languageFieldset: {
        legend: 'Språk',
        categoryName: 'Kategorinavn:',
        languageType: 'Språktype:',
        selectLanguage: 'Velg språk',
        categoryDescription: 'Kategori­beskrivelse:',
      },
      deleteCategory: 'Slett kategori',
      deleteConfirm: 'Er du sikker på at du vil slette denne kategorien?',
      categoryType: 'Kategoritype',
      validation: {
        categoryRequired: 'Minst én kategoritype er påkrevd',
        languageRequired: 'Språk er påkrevd',
      },
      languageOptions: {
        en: 'Engelsk',
        no: 'Norsk',
        se: 'Svensk',
        de: 'Tysk',
        fr: 'Fransk',
        es: 'Spansk',
      },
      categoryTypes: {
        device: 'Enhet',
        zone: 'Sone',
        service: 'Tjeneste',
        resource: 'Ressurs',
        activity: 'Aktivitet',
      },
    },

    userManagement: {
      auditLogs: {
        viewed: 'Lest',
        doneBy: 'Utført av',
        noAccess:
          'Du må ha nivå 4 (systemadministrator) eller høyere for å se revisjonslogger.',
      },
      auditChanges: {
        readQuery: 'Hva som ble lest',
        title: 'Hva ble endret',
        field: 'Felt',
        before: 'Før',
        after: 'Etter',
        created: 'Opprettet',
        updated: 'Oppdatert',
        deleted: 'Slettet',
        empty:
          'Ingen endringer i databasen ble registrert for denne forespørselen.',
        more: 'Flere poster ble endret enn det som vises her.',
        hidden: 'Skjult',
        largeValue: 'Stor verdi',
        items: 'elementer',
        sentData: 'Data som ble sendt',
      },
      list: {
        header: 'Brukeradministrasjon',
        addButton: 'Legg til bruker',
        emptyState: 'Ingen brukere funnet.',
        searchPlaceholder: 'Søk i brukere...',
        backButton: 'Tilbake til brukere',
      },

      feedback: {
        fetchError: 'En feil oppstod ved henting av brukere',
        updateSuccess: 'Bruker oppdatert',
        updateError: 'En feil oppstod under oppdatering av brukeren',
        createSuccess: 'Bruker opprettet',
        createError: 'En feil oppstod under oppretting av brukeren',
        saveError: 'En feil oppstod ved lagring av brukeren',
      },
    },

    editUser: {
      firstName: 'Fornavn',
      lastName: 'Etternavn',
      userInformation: 'Brukerinformasjon',
      mobileNumber: 'Mobilnummer',
      email: 'E-post',
      password: 'Passord',
      enovaOrganization: 'Organisasjon',
      enovaOrganizationNumber: 'Organisasjonsnr.',
      enovaPersonalGuid: 'Enova GUID',
      azureAccount: 'Azure-konto-ID',
      role: 'Rolle',
      active: 'Aktiv',
      acceptEmails: 'Godta e-poster',
      receiveEmails: 'Brukeren mottar system-eposter',
      canLogin: 'Brukeren kan logge inn og få tilgang til systemet',
      hideFeedback: 'Skjul tilbakemeldinger',
      hidePopups: 'Skjul tilbakemeldingspopups',
      changePassword: 'Endre passord',
      successUpdatePassword: 'Passord oppdatert',
      errorUpdatePassword: 'Kunne ikke oppdatere passord',
      passwordFeedback: 'Passordet må være minst 8 tegn',
      addNew: 'Legg til ny bruker',
      calendarSetup: 'Kalenderoppsett',
      calendarStartOfDay: 'Dagens start (for kalendervisning)',
      calendarEndOfDay: 'Dagens slutt',
      tenantAccess: {
        header: 'Kundetilgang',
        label: 'Kunde',
        addAccess: 'Legg til tilgang',
        selectTenant: '- Velg kunde -',
        assignedTenants: 'Tildelte kunder',
        feedback: {
          pleaseSelect: 'Velg en kunde',
          alreadyAdded: 'Kunde allerede lagt til',
        },
      },

      deleteUser: {
        label: 'Slett bruker',
        deleting: 'Sletter …',
      },
      confirmDelete: 'Er du sikker på at du vil slette denne brukeren?',
      activityLog: 'Aktivitetslogg',
    },

    integrationOverview: {
      edit: {
        details: {
          legend: 'Detaljer',
          nameLabel: 'Navn',
          activeLabel: 'Aktiv',
        },
        access: {
          legend: 'Tilgang',
          accessLevelLabel: 'Tilgangsnivå',
          dateFromLabel: 'Dato fra',
          dateToLabel: 'Dato til',
          accessLevelOptions: {
            noAccess: 'Ingen tilgang',
            readOnly: 'Kun lesing',
            readAndWrite: 'Les & skriv',
            admin: 'Admin',
          },
        },
        secrets: {
          legend: 'Nøkler',
          revealButton: 'Vis',
          publicKeyLabel: 'Offentlig nøkkel',
          secretKeyLabel: 'Hemmelig nøkkel',
        },
      },
      feedback: {
        updateSuccess: 'Integrasjon oppdatert',
        createSuccess: 'Integrasjon opprettet',
        saveError: 'Kunne ikke lagre',
        fetchSecretsError: 'Kunne ikke hente nøkler',
        fetchIntegrationsError: 'Kunne ikke hente integrasjoner',
      },
    },

    themeSettings: {
      header: {
        title: 'Temaer',
        subtitle: 'Opprett og administrer visuelle temaer for selskapet',
      },
      feedback: {
        activatedSuccess: '{themeName} tema aktivert',
        deletedSuccess: 'Tema slettet',
        updatedSuccess: 'Tema oppdatert',
        createdSuccess: 'Tema opprettet',
      },
      card: {
        customize: 'Tilpass',
        fallbackDescription: 'Et {name} tema',
        confirmDelete: 'Er du sikker på at du vil slette temaet "{name}"?',
      },
      globalThemes: {
        sunsetOrange: {
          name: 'Solnedgang',
          description: 'Varme oransje og koralltoner med sandige aksenter',
        },
        oceanBlue: {
          name: 'Havblå',
          description: 'Friske blåtoner inspirert av havet',
        },
        crimsonRed: {
          name: 'Karmosinrød',
          description: 'Dyp karmosin drevet av energiske rødtoner',
        },
        forestGreen: {
          name: 'Skoggrønn',
          description: 'Beroligende skoggrønntoner med naturlige aksenter',
        },
        blackAndWhite: {
          name: 'Svart og hvitt',
          description:
            'Tidløs kontrast i svart og hvitt for et moderne uttrykk',
        },
        classicGray: {
          name: 'Klassisk grå',
          description: 'Profesjonelt grått tema med subtile kontraster',
        },
        modernWhite: {
          name: 'Moderne hvit',
          description: 'Tidløs hvit for et rent, minimalistisk uttrykk',
        },
      },
      dialog: {
        editHeader: 'Rediger tema',
        createHeader: 'Opprett tema',
        createTitle: 'Opprett nytt tema',
        createDescription:
          'Design et egendefinert tema med dine farger og stil',
        namePlaceholder: 'Navn på temaet ditt',
        descriptionPlaceholder: 'Beskriv temaet ditt (valgfritt)',
        iconHover: 'Ikon ved hover',
        nameRequired: 'Temanavn er påkrevd',
        customSuffix: '(Tilpasset)',
      },
    },

    vendor: {
      title: 'Generelt',
      form: {
        name: 'Navn',
        contactDetails: 'Kontaktinformasjon',
        street: 'Gate',
        postcode: 'Postnummer',
        city: 'By',
        country: 'Land',
        timezone: 'Tidssone',
        selectTimezone: 'Angi tidssone',
        organizationNumber: 'Org.nr',
        phone: 'Kontakttelefon',
        email: 'Kontakt-e-post',
        website: 'Lenke til firmaside',
        languageDefault: 'Standardspråk',
        selectLanguage: 'Angi språk',
      },
      modules: {
        title: 'Moduler',
        threeDView: '3D-visning',

        requiredAttributes: {
          title: 'Obligatoriske attributter',
          firstName: 'Fornavn',
          lastName: 'Etternavn',
          phone: 'Telefon',
          email: 'E-post',
        },
        buildingAutomation: {
          title: 'Bygningsautomasjon',
          sastechTenantId: 'Sastech-kunde-ID',
          ignitionProjectName: 'Ignition prosjektnavn',
          gridRegion: 'Prisområde',
          selectGridRegion: '- Velg område -',
          gridRegions: {
            NO1: 'Østlandet NO1',
            NO2: 'Sørlandet NO2',
            NO3: 'Midt-Norge NO3',
            NO4: 'Nord-Norge NO4',
            NO5: 'Vestlandet NO5',
          },
        },
        publicDisplay: {
          title: 'Offentlig Visning',
          loginToDisplay: 'Logg inn for visning',
          invalidPassword: 'Ugyldig passord. Prøv igjen.',
          password: 'Passord',
          publicLink: 'Offentlig Visning-lenke:',
          description:
            'Vis nøkkeldata for bygningen på en offentlig skjerm uten brukergrensesnitt',

          placeholder: 'Angi nytt passord',
          leaveBlankHint: 'La stå tomt for å beholde gjeldende passord.',
          copyButton: 'Kopier',
          copySuccess: 'Lenke kopiert til utklippstavlen',
          saveVendorFirst: 'Lagre leverandøren for å generere en token',
          regenerateButton: 'Generer ny token',
          regenerateWarning:
            'Advarsel: Dette vil ugyldiggjøre den eksisterende lenken',
          confirmRegenerate:
            'Er du sikker på at du vil regenerere tokenet? Dette vil ugyldiggjøre den eksisterende lenken.',
          tokenRegenerated: 'Token regenerert',
          tokenRegenerateFailed: 'Kunne ikke regenerere token',
        },
      },
      logo: {
        title: 'Logo',
      },
      privacy: {
        title: 'Personvern & anonymisering',
        activateAnonymizing: 'Aktiver anonymisering',
        privacyPolicyText: 'Her angir du intervall for anonymisering',
        monthsToKeepData: 'Antall måneder å beholde data',
      },
      keyAccountManager: {
        title: 'Kundeansvarlig',
        notAssigned: 'Ikke tildelt',
      },
      tenantStatus: {
        title: 'Kundestatus',
        tenantIsActive: 'Kunden er aktiv',
        status: 'Status',
        fetchFailed: 'Kunne ikke hente kunder',
        options: {
          development: '1. Utvikling',
          readyForProduction: '2. Klar for produksjon',
          production: '3. Produksjon (system­satt)',
          deleted: 'Slettet',
        },

        markedForDeletion: 'Merket for sletting',
        vendorDeletionTitle: 'Sletting av leverandør',
        vendorDeletionDescription:
          'Systemet sletter leverandøren bare hvis den er merket for sletting, kundestatus er satt til «slettet», og leverandøren er inaktiv. Leverandøren slettes hvis modellen sist ble oppdatert for mer enn 30 dager siden, for å sikre at den ikke er i bruk.',
      },

      vendorIdLabel: 'Leverandør-ID',

      successMessage: 'Leverandør oppdatert',
      successMessagePassword: 'Leverandør oppdatert (Passord oppdatert)',
      errorMessage: 'Kunne ikke oppdatere leverandør',
    },

    imageUpload: {
      title: 'Bildeopplasting',
      layout: 'Oppsett',
      uploadImage: 'Last opp bilde',
      noFileSelected: 'Ingen fil valgt',
      uploading: 'Laster opp',
      fileSizeExceeded: 'Filstørrelsen overskrider grensen på {{size}} MB.',
      invalidFileType: 'Ugyldig filtype. Velg et bilde.',
      bytes: 'bytes',
      dropToReplace: 'Slipp bilde for å erstatte',
      dragHint: 'Dra og slipp her for å erstatte',
      fromFileCloud: 'Filsky',
      chooseFromFileCloud: 'Velg fra Filsky',
    },

    fileUpload: {
      uploadFile: 'Last opp fil',
      noFileSelected: 'Ingen fil valgt',
      uploading: 'Laster opp …',
      fileSizeExceeded: 'Filstørrelsen overskrider grensen på {{size}} MB.',
      invalidFileType: 'Ugyldig filtype. Velg en gyldig fil.',
      uploadFailed: 'Opplasting mislyktes. Prøv igjen',
      fileAlreadyUploaded: 'Fil er allerede lastet opp',
      viewUploadedFile: 'Vis opplastet fil',
      uploadNewFile: 'Last opp ny fil',
      fileLabel: 'Fil:',
      sizeLabel: 'Størrelse:',
    },

    fileCloud: {
      title: 'Filsky',
      storageTitle: 'Lagring',
      nameLabel: 'Navn',
      folderLabel: 'Mappe',
      sizeLabel: 'Størrelse',
      dateLabel: 'Dato oppdatert',
      buildingLabel: 'Bygg',
      currentPath: 'Gjeldende sti',
      rootLabel: 'Hjem',
      selectedLabel: 'valgt',
      gridViewLabel: 'Rutenettvisning',
      listViewLabel: 'Listevisning',
      header: 'Oppbevar, organiser og del filer sikkert i hele organisasjonen',
      uploadFiles: {
        dropZonePrompt: 'Dra og slipp filene dine her',
        selectedFilesHeader: 'Valgte filer:',
        uploadButton: 'Last opp',
        uploadFilesLabel: 'Last opp filer',
        uploadFolderLabel: 'Last opp mappe',
        uploadProgress: 'Laster opp {{done}} av {{total}} filer…',
      },
      noFiles: 'Dra og slipp filer',
      noBuildings: 'Ingen bygninger tilgjengelig.',
      menu: {
        download: 'Last ned',
        rename: 'Gi nytt navn',
        delete: 'Slett',
        setBuilding: 'Knytt bygning',
        clearBuilding: 'Fjern bygning',
      },
      dialog: {
        buildingTitle: 'Velg bygning',
        cancelButton: 'Avbryt',
        newFolderName: 'Navn på ny mappe',
        createFolder: 'Opprett mappe',
        renameFolder: 'Gi nytt navn på mappe',
        confirmDeleteTitle: 'Bekreft sletting',
        confirmDeleteMessage:
          'Er du sikker på at du vil slette den valgte filen?',
        confirmFolderDeleteMessage:
          'Er du sikker på at du vil slette den valgte mappen og alt innholdet i den?',
        invalidFolderName:
          'Mappenavnet inneholder ugyldige tegn eller er tomt.',
        duplicateFolderName: 'En mappe med dette navnet finnes allerede.',
        confirmDeleteSelectedMessage:
          'Er du sikker på at du vil slette de valgte filene?',
      },
      feedback: {
        // existing
        fileDeleted: 'Filen ble slettet',
        buildingCleared: 'Bygget ble tømt',
        buildingAssigned: 'Bygget ble tildelt',
        buildingUpdateError: 'Kunne ikke oppdatere byggtilknytningen.',

        // Restore file
        fileRestored: 'Filen ble gjenopprettet.',
        restoreSuccessfulTitle: 'Gjenoppretting fullført',
        restoreErrorMessage: 'Kunne ikke gjenopprette filen.',
        restoreErrorTitle: 'Feil ved gjenoppretting',

        // Empty garbage
        garbageEmptied: 'Papirkurven ble tømt.',
        emptyGarbageSuccessfulTitle: 'Tømming av papirkurv fullført',
        emptyGarbageErrorMessage: 'Kunne ikke tømme papirkurven.',
        emptyGarbageErrorTitle: 'Feil ved tømming av papirkurv',

        // Move folder to garbage
        folderMovedToGarbage: 'Mappen ble flyttet til papirkurven.',
        moveFolderToGarbageSuccessfulTitle: 'Flytting til papirkurv fullført',
        moveFolderToGarbageErrorMessage:
          'Kunne ikke flytte mappen til papirkurven.',
        moveFolderToGarbageErrorTitle: 'Feil ved flytting til papirkurv',

        // Rename folder
        folderRenamed: 'Mappen ble endret navn på.',
        renameFolderSuccessfulTitle: 'Navneendring fullført',
        renameFolderErrorMessage: 'Kunne ikke endre navn på mappen.',
        renameFolderErrorTitle: 'Feil ved navneendring',

        // Move folder
        folderMoved: 'Mappen ble flyttet.',
        moveFolderSuccessfulTitle: 'Flytting fullført',
        moveFolderErrorMessage: 'Kunne ikke flytte mappen.',
        moveFolderErrorTitle: 'Feil ved flytting',

        // Delete file
        deleteSuccessfulTitle: 'Sletting fullført',
        deleteErrorMessage: 'Kunne ikke slette filen.',
        deleteErrorTitle: 'Feil ved sletting',

        // Move file
        moveFileErrorMessage: 'Kunne ikke flytte filen.',
        moveFileErrorTitle: 'Feil ved flytting',

        // Create folder
        createFolderErrorMessage: 'Kunne ikke opprette mappe.',
        createFolderErrorTitle: 'Feil ved oppretting av mappe',

        // Upload
        uploadSuccessfulMessage: 'Filene ble lastet opp.',
        uploadSuccessfulTitle: 'Opplasting fullført',
        uploadErrorTitle: 'Feil ved opplasting',
      },

      newFolder: 'Ny mappe',
      confirmDeleteFolder:
        'Er du sikker på at du vil slette denne mappen og alt innholdet i den?',
      moveToRoot: 'Flytt til rotmappen',
    },

    feedback: {
      vendorLoad: {
        title: 'Feil',
        message: 'Kunne ikke laste leverandørinformasjon',
      },
    },
    degreeDays: {
      error: 'Bygningen mangler GPS-koordinater',
    },
  },
  feedback: {
    open: 'Tilbakemelding',
    title: 'Send tilbakemelding',
    close: 'Lukk',
    messageLabel: 'Melding',
    placeholder: 'Skriv din tilbakemelding her…',
    screenshotTitle: 'Last opp skjermbilde',
    send: 'Send',
    infoPrefix: 'For mer informasjon, se',
    helpCenter: 'Hjelpesenter',
    statusPage: 'Statusside',
  },
  admin: {
    buildingInspection: BUILDING_INSPECTION,
    energyLabelLeads: ENERGY_LABEL_LEADS,
    siteInspection: {
      deleteNoSiteInspectionsMessage: 'Ingen befaring valgt for sletting.',
      deleteConfirmMessage:
        'Er du sikker på at du vil slette denne befaringen? Dette kan ikke angres.',
      deleteSuccessMessage: 'Befaringen er slettet.',
      deleteErrorMessage: 'Kunne ikke slette befaringen.',
      updateSuccessMessage: 'Befaring oppdatert.',
      createSuccessMessage: 'Befaring opprettet.',
      failedToLoadMessage:
        'Kunne ikke laste inn befaringer. Prøv igjen senere.',
      saveErrorMessage: 'Kunne ikke lagre befaringen. Prøv igjen senere.',
      buildingErrorMessage: 'Vennligst velg en bygning for befaringen.',
      buildingTypeErrorMessage:
        'Vennligst velg en bygningstype for befaringen.',
      failedToLoadBuildingsMessage:
        'Kunne ikke laste inn bygninger. Prøv igjen senere.',
      calculationsCompleteMessage: 'Beregninger er fullført',
      fetchError: 'Kunne ikke hente bygninger.',
      fetchErrorById: 'Kunne ikke hente befaring.',
      confirmDeletion: {
        title: 'Bekreft sletting',
        hvacUnit: 'Ventilasjonsaggregat',
        heatingCoolingModule: 'Oppvarmings-/kjølemodul',
        productionEquipment: 'Produksjonsutstyr',
        zone: 'Sone',
        excessEnergyModule: 'Overskuddsenergimodul',
        confirmMessage: 'Er du sikker på at du vil slette',
      },
      //Header
      title: 'Befaring',
      subtitle: 'Fullfør befaringen ved å bruke veiledningsskjemaet nedenfor',
      newInspectionLabel: 'Ny befaring, lagre for å aktivere flere valg.',
      reportLabel: 'Rapport',
      actionsLabel: 'Tiltak',
      generalLabel: 'Generelt',
      //Info
      status: {
        statusLabel: 'Status',
        draft: 'Utkast',
        completed: 'Fullført',
        inReview: 'Under vurdering',
      },
      buildingLabel: 'Bygning',
      buildingTypeLabel: 'Bygningstype (NS-standard)',
      notesLabel: 'Notater',
      buildingTypes: {
        label: {
          smallHouse: 'Småhus',
          apartmentBlock: 'Boligblokk',
          kinderGarden: 'Barnehage',
          officeBuilding: 'Kontorbygning',
          schoolBuilding: 'Skolebygning',
          universityCollege: 'Universitet / Høyskole',
          hospital: 'Sykehus',
          nursingHome: 'Sykehjem',
          hotel: 'Hotell',
          sportsBuilding: 'Idrettsbygning',
          commercialBuilding: 'Forretningsbygning',
          culturalBuilding: 'Kulturbygning',
          lightIndustryWarehouse: 'Lett industri / Lagerbygning',
        },
        description: {
          smallHouse:
            'Enebolig, tomannsbolig, rekkehus, kjedehus eller andre små boliger.',
          apartmentBlock:
            'Boligblokk med to eller flere etasjer, inkludert større rekkehus med flere etasjer.',
          kinderGarden:
            'Bygninger beregnet for barnehage eller tidlig barndomsopplæring.',
          officeBuilding:
            'Enkle kontorer, kontorer med ventilasjon og kjøling, eller utstillings- og kongressbygninger.',
          schoolBuilding:
            'Undervisningslokaler, inkludert skoler med svømmehall eller idrettshall.',
          universityCollege:
            'Universitets- eller høyskolebygninger, laboratoriebygg eller forskningsfasiliteter.',
          hospital:
            'Sykehus, pasienthotell eller laboratoriebygninger til medisinsk bruk.',
          nursingHome: 'Sykehjemsbygninger for langtidsopphold og pleie.',
          hotel:
            'Hoteller, restaurantbygninger eller andre bygninger for overnatting.',
          sportsBuilding:
            'Idrettshaller, svømmebasseng og andre idrettsanlegg med garderober og dusjområder.',
          commercialBuilding:
            'Butikker, forretningslokaler med kjøle- eller fryserom, eller bensinstasjoner.',
          culturalBuilding: 'Kinoer, museer, biblioteker og religiøse bygg.',
          lightIndustryWarehouse:
            'Industribygg, lagerbygg, fiskeri-/landbruksbygg, energiforsyningsanlegg eller andre verksteder.',
        },
      },
      mainTabs: {
        info: 'Informasjon',
        climate: 'Klima',
        zones: 'Soner',
        hvac: 'Ventilasjon og drift',
        heatingCooling: 'Oppvarming og kjøling',
        excessEnergy: 'Overskuddsenergi',
        analytics: 'Analyse',
        attachments: 'Vedlegg',
      },
      footerButtons: {
        next: 'Neste',
        previous: 'Forrige',
      },
      climate: {
        averageMonthlyTemp: 'Gjennomsnittlig månedstemperatur (°C)',
        globalIrradiation: 'Global solinnstråling (kWh/m²)',
        diffuseIrradiation: 'Diffus solinnstråling (kWh/m²)',
        albedo: 'Albedo (0–1)',
      },
      hvacTabs: {
        hvacUnits: 'Ventilasjonsaggregater',
        operationalLoads: 'Driftslaster',
        productionEquipment: 'Produksjonsutstyr',
      },
      zoneManager: {
        area: 'Areal (m²)',
        noZonesCreatedYet: 'Ingen soner opprettet ennå',
        createZoneToBegin:
          'Opprett en sone for å begynne å samle inn data om bygningskroppen. Du kan enten velge en eksisterende bygningssone eller opprette en ny for denne befaringen.',
        subTabs: {
          buildingEnvelope: 'Bygningskropp',
          windows: 'Vinduer',
          doors: 'Dører',
          gates: 'Porter',
          airLeakage: 'Luftlekkasje',
          thermalMass: 'Termisk masse',
        },
        zoneSelector: {
          createFirstZone: 'Opprett sone',
          addZone: 'Legg til sone',
          deleteSelectedZone: 'Slett valgt sone',
          linked: 'Koblet',
          editZoneName: 'Rediger sonenavn',
          editZoneNameTitle: 'Rediger sonenavn',
          zoneNameLabel: 'Sonenavn',
          cancelButton: 'Avbryt',
          saveButton: 'Lagre',
          updateError: 'Kunne ikke oppdatere sonenavn',
          updateSuccess: 'Sonenavn oppdatert',
        },
        zoneCreateModal: {
          zoneNameError: 'Sonenavn er påkrevd.',
          createNewZoneLabel: 'Opprett ny sone',
          linkExistingZoneLabel: 'Koble til eksisterende sone',
          linkExistingZoneHelperText:
            'Velg en eksisterende sone som skal kobles til denne befaringen.',
          selectZonePlaceholder: 'Velg en sone...',
          createNewZoneHelperText:
            'Opprett en ny sone som legges til bygningen og brukes i denne befaringen.',
          zoneName: 'Sonenavn',
          description: 'Beskrivelse',
          cancelButtonLabel: 'Avbryt',
          addZoneTitle: 'Legg til sone',
          zoneNameLabel: 'Sonenavn',
          descriptionLabel: 'Beskrivelse',
        },
        exteriorWalls: 'Yttervegger',
        helperWithHistory: {
          north: 'Nord',
          south: 'Sør',
          east: 'Øst',
          west: 'Vest',
          count: 'Antall',
          width: 'Bredde (m)',
          height: 'Høyde (m)',
          addToArea: 'Legg til areal (m²)',
          history: 'Historikk',
          entry: ' Beregning',
          entries: ' Beregninger',
          inputHistory: 'Beregeningshistorikk',
          helperTitle: 'Areal kalkulator',
        },
        windows: {
          glassType: 'Glasstype',
          windowTypes: [
            'Ingen',
            'Enkeltglass',
            '2-lags glass',
            '2-lags energiglass',
            '2-lags solreflekterende glass',
            '3-lags energiglass',
          ],
          totalWindowsArea: 'Totalt vindusareal (m²)',
          sumOfAllWindowsSurfaces: 'Sum av alle vindusflater',
          averageUValue: 'Gjennomsnittlig U-verdi (W/m²K)',
          averageUValueFormula: '(Σ(U × areal)) / Σ(areal)',
          winAreaAsPercentageOfFacade: 'Vindusareal som % av fasade',
          winAreaAsPercentageOfFacadeFormula:
            'Totalt vindusareal / Total fasadeareal × 100',
        },
        buildingEnvelope: {
          bra: 'Oppvarmet bruksareal (m²)',
          floors: 'Antall etasjer',
          floorHeight: 'Etasjehøyde (m)',
          indoorTemperature: 'Innetemperatur (°C)',
          heatedVolume: 'Oppvarmet luftvolum (m³)',
          heatedVolumeFormula: 'BRA × etasjehøyde',
          thermalBridge: 'Kuldebro',
          thermalBridgeFormula: 'Oppvarmet areal × normverdi × Kelvin',
          totalExternalWallArea: 'Totalt ytterveggsareal',
          totalExternalWallAreaFormula: 'Sum av ytterveggsflater',
          thermalBridgeCoefficient: 'Kuldebrokoeffisient (W/mK)',
          extwWallConstruction: 'Ytterveggskonstruksjonstype',
          groundConditions: {
            title: 'Grunnforhold',
            options: {
              none: 'Ingen',
              clay: 'Leire',
              drySandGravel: 'Sand/grus (tørr)',
              moistSandGravel: 'Sand/grus (fuktig)',
              wetSandGravel: 'Sand/grus (våt)',
              rock: 'Fjell',
              moraine: 'Morene',
              dryPeat: 'Torv (tørr)',
              moistPeat: 'Torv (fuktig)',
              wetPeat: 'Torv (våt)',
              silt: 'Silt',
              organicSoil: 'Organisk jord',
            },
            heatCapacity: 'Varmekapasitet (J/m²K)',
            thermalConductivity: 'Varmeledningsevne (W/mK)',
            groundTemperature: 'Grunntemperatur (°C)',
          },
          grossArea: 'Bruttoareal (m²)',
          netArea: 'Nettoareal (m²)',
          netAreaFormula: 'Veggareal - Vinduer - Dører - Porter',
          wallConstruction: {
            title: 'Veggkonstruksjon',
          },
          uValue: 'U-verdi (W/m²K)',
          shadingFactor: 'Skyggefaktor',
          area: 'Areal (m²)',
          yearInstalled: 'År installert',
          yearInstalledNone: 'Ingen',
          yearInstalledBefore1949: 'Før 1949',
          yearInstalledFrom1997: 'Fra 1997 og senere',
          floor: {
            area: 'Gulvareal (m²)',
            uValue: 'Gulv U-verdi (W/m²K)',
            title: 'Gulv',
            options: {
              title: 'Type gulvmateriale',
              standard: 'Standard',
              tiles: 'Fliser (7 mm) + betong',
              flooringChipBoard: 'Gulvbelegg (4 mm) + 22 mm sponplate',
              flooringConcrete: 'Gulvbelegg (4 mm) + betong',
              flooringLWA: 'Gulvbelegg (4 mm) + lettklinkerdekke',
              parquetChipBoard: 'Parkett (14 mm) + 22 mm sponplate',
              parquetConcrete: 'Parkett (14 mm) + betong',
              parquetLWA: 'Parkett (14 mm) + lettklinkerdekke',
              carpetChipBoard: 'Teppe (10 mm) + 22 mm sponplate',
              carpetConcrete: 'Teppe (10 mm) + betong',
              carpetLWA: 'Teppe (10 mm) + lettklinkerdekke',
            },
          },
          roof: {
            title: 'Tak',
            optionsTitle: 'Takkonstruksjon',
            area: 'Takareal (m²)',
            uValue: 'Tak U-verdi (W/m²K)',
            options: [
              'Standard',
              'Kompakttak m. 200–250 mm betong, 200 mm isolasjon',
              'Kompakttak m. 200–250 mm betong, 250 mm isolasjon',
              'Kompakttak m. 200–250 mm betong, 300 mm isolasjon',
              'Kompakttak m. 200–250 mm betong, 350 mm isolasjon',
              'Kompakttak m. 200–250 mm betong, 400 mm isolasjon',
              'Kompakttak m. 200–250 mm betong, 450 mm isolasjon',
              'Kompakttak m. 200–250 mm betong, 500 mm isolasjon',
              'Kompakttak m. korrugert stålplate, 200 mm isolasjon',
              'Kompakttak m. korrugert stålplate, 250 mm isolasjon',
              'Kompakttak m. korrugert stålplate, 300 mm isolasjon',
              'Kompakttak m. korrugert stålplate, 350 mm isolasjon',
              'Kompakttak m. korrugert stålplate, 400 mm isolasjon',
              'Kompakttak m. korrugert stålplate, 450 mm isolasjon',
              'Kompakttak m. korrugert stålplate, 500 mm isolasjon',
              'Skråtak m. 48 mm sperrer (9 % arealandel), 200 mm isolasjon',
              'Skråtak m. 48 mm sperrer (9 % arealandel), 250 mm isolasjon',
              'Skråtak m. 48 mm sperrer (9 % arealandel), 300 mm isolasjon',
              'Skråtak m. 48 mm sperrer (9 % arealandel), 350 mm isolasjon',
              'Skråtak m. 48 mm sperrer (9 % arealandel), 400 mm isolasjon',
              'Skråtak m. I-profil sperrer (6 % arealandel), 200 mm isolasjon',
              'Skråtak m. I-profil sperrer (6 % arealandel), 250 mm isolasjon',
              'Skråtak m. I-profil sperrer (6 % arealandel), 300 mm isolasjon',
              'Skråtak m. I-profil sperrer (6 % arealandel), 350 mm isolasjon',
              'Skråtak m. I-profil sperrer (6 % arealandel), 400 mm isolasjon',
              'Skråtak m. I-profil sperrer (6 % arealandel), 450 mm isolasjon',
              'Skråtak m. I-profil sperrer (6 % arealandel), 500 mm isolasjon',
              'Skråtak m. I-profil sperrer (6 % arealandel), 550 mm isolasjon',
              'Tak m. kaldt loft, 48 mm bjelker (9 % arealandel), 200 mm isolasjon',
              'Tak m. kaldt loft, 48 mm bjelker (9 % arealandel), 250 mm isolasjon',
              'Tak m. kaldt loft, 48 mm bjelker (9 % arealandel), 300 mm isolasjon',
              'Tak m. kaldt loft, 48 mm bjelker (9 % arealandel), 350 mm isolasjon',
              'Tak m. kaldt loft, 48 mm bjelker (9 % arealandel), 400 mm isolasjon',
              'Tak m. kaldt loft, 48 mm bjelker (9 % arealandel), 450 mm isolasjon',
              'Tak m. kaldt loft, 48 mm bjelker (9 % arealandel), 500 mm isolasjon',
              'Tak m. kaldt loft, 48 mm bjelker (9 % arealandel), 550 mm isolasjon',
            ],
          },
          basement: {
            title: 'Kjeller',
            area: 'Kjellerareal (m²)',
            wallHeight: 'Vegghøyde (m)',
            wallThickness: 'Veggtykkelse (m)',
            baseWallConstruction: 'Veggkonstruksjon',
            wallUValue: 'U-verdi (W/m²K)',
            heatStorage: 'Type varmelagring',
            effectiveHeatCapacity: 'Effektiv varmekapasitet (kJ/m²K)',
            floorConstruction: 'Gulvkonstruksjon',
            baseWallConstructionType: 'Veggkonstruksjonstype',
            baseWallConstructionOptions: [
              'Standard',
              '200 mm betong med 100 mm isolasjon',
              '200 mm betong med 150 mm isolasjon',
              '200 mm betong med 200 mm isolasjon',
              '200 mm betong med 250 mm isolasjon',
              '200 mm betong med 300 mm isolasjon',
              '300 mm betong med 100 mm isolasjon',
              '300 mm betong med 150 mm isolasjon',
              '300 mm betong med 200 mm isolasjon',
              '300 mm betong med 250 mm isolasjon',
              '300 mm betong med 300 mm isolasjon',
            ],
            heatStorageTypes: [
              'Ingen',
              'Lett (< 50 Wh/m²K)',
              'Middels (50–100 Wh/m²K)',
              'Tung (100–150 Wh/m²K)',
              'Meget tung (> 150 Wh/m²K)',
              '100 mm betong',
              '150 mm betong',
              '200 mm betong',
              '250 mm betong',
              '300 mm betong',
              'Trevirke',
              'Gips',
            ],
            floorConstructionTypes: [
              'Ingen',
              'Standard',
              'Betong på grunn med 100 mm isolasjon',
              'Betong på grunn med 150 mm isolasjon',
              'Betong på grunn med 200 mm isolasjon',
              'Betong på grunn med 250 mm isolasjon',
              'Betong på grunn med 300 mm isolasjon',
              'Betong på grunn med 350 mm isolasjon',
              'Betong på grunn med 400 mm isolasjon',
              'Trebjelkelag med 200 mm isolasjon',
              'Trebjelkelag med 250 mm isolasjon',
              'Trebjelkelag med 300 mm isolasjon',
            ],
          },
        },
        doors: {
          title: 'Dørtype',
          yearInstalled: 'År installert',
          totalArea: 'Totalt dørareal',
          totalAreaFormula: 'Sum av alle dørflater',
          avgUValue: 'Gjennomsnittlig U-verdi (dører)',
          avgUValueFormula: '(Σ(U × areal)) / Σ(areal)',
          percentageOfFacade: 'Dørareal som % av fasade',
          percentageOfFacadeFormula:
            'Totalt dørareal / Total fasadeareal × 100',
          doorTypes: [
            'Ingen',
            'Standard',
            'Isolert',
            'Normal',
            'Godt isolert',
            'Uisolert',
          ],
        },
        gates: {
          title: 'Porttype',
          yearInstalled: 'År installert',
          totalArea: 'Totalt portareal',
          totalAreaFormula: 'Sum av alle portflater',
          avgUValue: 'Gjennomsnittlig U-verdi (porter)',
          avgUValueFormula: '(Σ(U × areal)) / Σ(areal)',
          percentageOfFacade: 'Portareal som % av fasade',
          percentageOfFacadeFormula:
            'Totalt portareal / Total fasadeareal × 100',
        },
        airLeakage: {
          airLeakageRate: 'Luftlekkasje (l/s·m² ved 50 Pa)',
          airChangeRate: 'Luftvekslingsrate (ACH ved 50 Pa)',
          naturalVentilation: 'Naturlig ventilasjon',
        },
        thermalMass: {
          buildingHeatCapacity: 'Hele sonens varmekapasitet',
          heatCapacitySelectTitle: 'Bygningstype (NS 3031 B.2.8)',
          shortDescriptionFirstOption:
            'Lett bjelkelag, tynt gulvbelegg, lette vegger',
          shortDescriptionSecondOption:
            'Akustisk himling, teppe over betong, lette vegger',
          shortDescriptionThirdOption:
            'Lite eksponert betong (20 %), parkett over betong',
          shortDescriptionFourthOption: 'Hovedsakelig eksponert betong (70 %)',
          shortDescriptionFifthOption:
            'Eksponert betong i himling, vegger og gulv',
          labelFirstOption: 'Meget lett bygning',
          labelSecondOption: 'Lett bygning',
          labelThirdOption: 'Middels tung bygning',
          labelFourthOption: 'Tung bygning',
          labelFifthOption: 'Meget tung bygning',
          normalizedHeatCapacity: 'Varmekapasitet [Wh/m²K]',
          normalizedHeatCapacityHelper:
            'Fra NS 3031 Tabell B.8 – Brukes i dynamisk energiberegning',
          interiorWalls: 'Innervegger',
          north: 'Nord',
          south: 'Sør',
          east: 'Øst',
          west: 'Vest',
          claddingTitle: 'Kledningstype',
          cladding: [
            'Tilpasset',
            'Standard',
            '100 mm (eller mer) betong',
            '80 mm betong',
            'Gassbetong',
            'Gips 13 mm',
            'Lett tegl',
            'Lettklinker',
            'Massivtre (tykkelse over 40 mm)',
            'Trepanel 15 mm',
            'Tung (kompakt) tegl',
          ],
          claddingSubText: 'Brukerdefinert',
          internalConstruction: 'Intern konstruksjon',
          heatCapacity: 'Varmekapasitet [Wh/m²K]',
          grade: 'Klasse',
          furniture: {
            title: 'Møbler',
            options: ['Ingen', 'Standard', 'Lett', 'Middels', 'Tung'],
          },
          thermalHeatCapacityLabel: 'Termisk varmekapasitet',
          thermalHeatCapacityFormula:
            'BRA × normverdi / 1000 (Norm: Ingen = 0, Lett = 40, Middels = 60, Tung = 80 Wh/m²K)',
          floorSeparationsAreaLabel: 'Areal av etasjeskillere (m²)',
          internalFloorsTooltip:
            'Innvendige etasjeskillere mellom etasjer: BRA × (etasjer − 1) / etasjer',
        },
      },
    },
    report: {
      noReportYetTitle: 'Ingen rapport ennå',
      noReportYetDescription:
        'Opprett et første rapportutkast for å komme i gang med dokumentasjon av befaringen.',
      noReportYetSubDescription:
        'Rapporten vil inneholde kapitler, tekstfelt og vedlegg strukturert i et oversiktlig format.',
      creatingDraft: 'Oppretter utkast…',
      createDraft: 'Opprett utkast',

      title: 'Rapport',
      reportGenerationHint1:
        'For å generere rapporten må status for befaring settes til fullført.',
      reportGenerationHint2: 'Rapporter genereres hvert kvarter.',
      reportGenerationHint3:
        'Data hentes fra befaringen når status er satt til fullført.',
      statusDraft: 'Utkast',
      statusAiGenerate: 'AI-generering',
      statusComplete: 'Fullført',

      reportGenerationTitle: 'Rapportgenerering',
      reportGenerationLine1:
        'For å generere rapporten må status for befaring settes til fullført. Rapportene genereres hvert kvarter.',
      reportGenerationLine2:
        'Data hentes fra befaringen når status er satt til fullført.',

      tableOfContents: 'Innholdsfortegnelse',

      olderVersionWarning:
        'Advarsel! Du ser på en eldre versjon av denne rapporten.',

      saving: 'Lagrer…',
      saveReport: 'Lagre rapport',
      deleteReport: 'Slett rapport',

      confirmDeletionTitle: 'Bekreft sletting',
      confirmDeleteReportMessage:
        'Er du sikker på at du vil slette denne rapporten?',
      confirmDeleteTextFieldMessage:
        'Er du sikker på at du vil slette dette tekstfeltet?',

      addField: 'Legg til felt',
      fieldSingular: 'felt',
      fieldsPlural: 'felter',

      aiPrompt: 'AI-prompt',
      reportText: 'Rapporttekst',
      attachments: 'Vedlegg',
      addImage: 'Legg til bilde',
      confirmDeleteImage: 'Er du sikker på at du vil slette dette bildet?',

      aiLabel: 'AI',
      scoreLabel: 'Poeng',

      versionLabel: 'Versjon',

      exportToWord: 'Eksporter til Word',
      exportingWord: 'Eksporterer...',
      wordExportProgress: {
        starting: 'Starter eksport...',
        capturingCharts: 'Fanger opp diagrammer...',
        capturingDetails: 'Fanger opp beregningsdetaljer...',
        buildingDocument: 'Bygger dokument...',
        savingFile: 'Lagrer fil...',
        complete: 'Eksport fullført',
        error: 'Eksport feilet. Vennligst prøv igjen.',
      },
    },
    UserCalendar: {
      createYourActivity: 'Opprett din aktivitet',
      categoryErrorMessage: 'Kategori Mangler',
      titleErrorMessage: 'Tittel Mangler',
      createActivity: 'Opprett aktivitet',
      editActivity: 'Rediger aktivitet',
      confirmDeletion: 'Bekreft sletting',
      deleteMessage: 'Er du sikker på at du vil slette denne aktiviteten?',
    },
  },

  attachments: {
    notes: 'Notater',
    description: 'Beskrivelse',
    replaceImage: 'Bytt bilde',
    addImage: 'Legg til bilde',
    removeAttachment: 'Fjern vedlegg',
    tags: 'Emner',
    uploadImage: 'Last opp skjermbilde',
  },
  buildingControlProfile: {
    inOperationTitle: 'I drift',
    outsideOperationTitle: 'Utenfor drift',
    temperatureLower: 'Nedre temperaturgrense (°C)',
    temperatureUpper: 'Øvre temperaturgrense (°C)',
    humidityLower: 'Nedre fuktighetsgrense (%)',
    humidityUpper: 'Øvre fuktighetsgrense (%)',
    co2Tooltip: 'Maksimalt CO₂-nivå tillatt',
    refreshInterval: 'Sjekkintervall',
    refreshIntervalHelp: 'Hvor ofte ASPA sjekker disse instillingene',
    comfortWeight: 'Komfortvekt',
    energy: 'Energi',
    comfort: 'Komfort',
    costInfo:
      'ASPA balanserer energiforbruk og komfort. Lav komfortvekt prioriterer lavt energiforbruk, mens høy komfortvekt prioriterer bedre komfort. Begge verdiene beregnes på en skala fra 0 til 1.',
  },
  gridRegions: {
    label: 'Strømsone',
    placeholder: '- Velg område -',
    groups: {
      nordic: 'Norden',
      centralEurope: 'Sentral-Europa',
      southernEurope: 'Sør-Europa',
      baltic: 'Baltikum',
      britishIsles: 'De britiske øyer',
      easternEurope: 'Øst-Europa',
    },
    areas: {
      NO1: 'Oslo / Øst-Norge',
      NO2: 'Kristiansand / Sør-Norge',
      NO3: 'Trondheim / Midt-Norge',
      NO4: 'Tromsø / Nord-Norge',
      NO5: 'Bergen / Vest-Norge',
      SE1: 'Nord-Sverige',
      SE2: 'Midtre Nord-Sverige',
      SE3: 'Midt-Sverige',
      SE4: 'Sør-Sverige',
      DK1: 'Vest-Danmark (Jylland-Fyn)',
      DK2: 'Øst-Danmark (Sjælland)',
      FI: 'Finland',
      DE_LU: 'Tyskland-Luxembourg',
      AT: 'Østerrike',
      BE: 'Belgia',
      NL: 'Nederland',
      FR: 'Frankrike',
      CH: 'Sveits',
      CZ: 'Tsjekkia',
      PL: 'Polen',
      SK: 'Slovakia',
      HU: 'Ungarn',
      SI: 'Slovenia',
      HR: 'Kroatia',
      IT_NORTH: 'Italia nord',
      IT_CNORTH: 'Italia midtre nord',
      IT_CSOUTH: 'Italia midtre sør',
      IT_SOUTH: 'Italia sør',
      IT_SICILY: 'Italia Sicilia',
      IT_SARDINIA: 'Italia Sardinia',
      ES: 'Spania',
      PT: 'Portugal',
      GR: 'Hellas',
      EE: 'Estland',
      LV: 'Latvia',
      LT: 'Litauen',
      GB: 'Storbritannia',
      IE_SEM: 'Irland (SEM)',
      RO: 'Romania',
      BG: 'Bulgaria',
      RS: 'Serbia',
      ME: 'Montenegro',
      AL: 'Albania',
      MK: 'Nord-Makedonia',
      BA: 'Bosnia-Hercegovina',
      XK: 'Kosovo',
    },
  },
  addressSearch: {
    label: 'Søk på adresse',
    placeholder: 'Gate, nummer og sted',
    moreHint:
      'Viser {shown} av {total}. Legg til sted eller postnummer for å begrense søket.',
    noHitsHint:
      'Ingen treff. Legg til husnummer og sted, for eksempel Storgata 1 Oslo.',
  },
  energyLabelForm: {
    eyebrow: 'Energiattest',
    language: 'Språk',
    themeLight: 'Bytt til lyst tema',
    themeDark: 'Bytt til mørkt tema',
    title: 'Energimerke',
    loggedInAs: 'Logget inn som',
    logout: 'Logg ut',
    login: {
      title: 'Logg inn',
      phoneDescription:
        'Logg inn med telefonnummeret ditt. Du får en bekreftelseskode på SMS.',
      codeDescription: 'Skriv inn den sekssifrede koden fra SMS-en.',
      phone: 'Telefonnummer',
      phonePlaceholder: '400 00 000',
      countryCode: 'Landskode',
      phoneHint: 'Koden sendes til dette nummeret.',
      code: 'Bekreftelseskode',
      codeHint: 'Seks siffer fra SMS-en.',
      codeSentTo: 'Koden er sendt til',
      sendCode: 'Send kode',
      sendingCode: 'Sender kode …',
      verify: 'Bekreft',
      verifying: 'Logger inn …',
      changePhone: 'Bruk et annet telefonnummer',
      resendCode: 'Send ny kode',
      codeResent: 'En ny kode er sendt.',
      errors: {
        invalidPhone: 'Sjekk telefonnummeret og prøv igjen.',
        invalidCode: 'Koden stemmer ikke. Prøv igjen.',
        noCode: 'Be om en ny kode.',
        codeExpired: 'Koden er utløpt. Be om en ny kode.',
        tooManyAttempts: 'For mange forsøk. Be om en ny kode.',
        buildingIncomplete:
          'Vi mangler opplysninger om bygget for å åpne skjemaet. Ta kontakt med oss.',
        generic: 'Noe gikk galt. Prøv igjen.',
      },
    },
    flow: {
      navTitle: 'Slik går du fram',
      knowInstallYear: 'Vet du installasjonsåret?',
      assumeBuildYear: 'Vi antar at det er fra {year}.',
      buildYearWord: 'byggeåret',
      assumeStandard: 'Vi antar standardverdier.',
      draftSavedAt: 'Ditt utkast — sist lagret',
      continueLater: 'Du kan lukke og fortsette senere.',
      draft: 'Utkast',
      saveAndClose: 'Lagre og lukk',
      autosaved: 'Svarene dine lagres automatisk.',
      submitted: {
        title: 'Sendt inn',
        body: 'Takk. En energirådgiver går gjennom svarene dine.',
      },
      submittedPage: {
        title: 'Takk! Skjemaet er sendt inn',
        body: 'Vi har mottatt svarene dine. Du trenger ikke gjøre noe mer nå.',
        building: 'Bygg',
        sentAt: 'Sendt inn',
        nextSteps:
          'En energirådgiver går gjennom svarene og tar kontakt hvis noe mangler.',
        review: 'Se svarene dine',
        logout: 'Logg ut',
      },
      back: 'Tilbake',
      next: 'Neste',
      submit: 'Send inn',
      stepsMenu: 'Steg',
      whyWeAsk: 'Hvorfor spør vi?',
      validation: {
        range: 'Må være mellom {min} og {max}.',
        min: 'Må være minst {min}.',
        max: 'Kan ikke være mer enn {max}.',
        positive: 'Må være over null.',
      },
      select: 'Velg',
      gnr: 'Gnr',
      bnr: 'bnr',
      buildingNumberShort: 'bygningsnr',
      building: {
        address: 'Adresse',
        buildingNumber: 'Bygningsnr',
        cadastre: 'Gnr / bnr',
        buildingType: 'Bygningstype',
        usableArea: 'Bruksareal (BRA)',
        footprint: 'Grunnflate',
      },
      cadastre: {
        notFound: 'Fant ikke bygget i Eiendomsregisteret. Fyll ut det du vet.',
      },
      yesNo: { yes: 'Ja', no: 'Nei', dontKnow: 'Vet ikke' },
      status: {
        completed: 'Fullført',
        defaults: 'Standardverdier',
        notApplicable: 'Ikke aktuelt',
      },
      steps: {
        confirmBuilding: {
          nav: 'Bekreft bygget',
          title: 'Bekreft bygget',
          eyebrow: 'Funnet via GPS og Eiendomsregisteret',
          question: 'Er dette bygget ditt?',
          body: 'Vi har markert bygget nærmest posisjonen din. Sjekk at adresse og bygningsnummer stemmer før du går videre.',
          wrongHint:
            'Stemmer det ikke? Trykk på riktig bygg i kartet, eller søk på adresse.',
          searchAddress: 'Søk på adresse',
          mapTitle: 'Bygningsvelger',
          noBuilding: 'Fant ingen bygning her. Dra markøren nærmere bygget.',
        },
        aboutBuilding: {
          nav: 'Om bygget',
          title: 'Om bygget',
          knowMore: 'Vet du mer om arealene?',
          lead: 'Det meste under er hentet fra Eiendomsregisteret. Rett det som ikke stemmer — attesten bygger på disse tallene.',
          aside: {
            title: 'Kategori, byggeår og areal',
            body: 'Bygningskategori, byggeår og bruksareal er grunnlaget for hele beregningen. Kategorien styrer standardverdiene, byggeåret sier hvilke byggeforskrifter som gjaldt, og arealet avgjør hvor mye energi bygget bruker per kvadratmeter.',
          },
          sections: {
            category: {
              title: 'Bygningskategori',
              description:
                'Kategorien styrer hvilke standardverdier som brukes videre.',
            },
            area: {
              title: 'Areal og høyde',
              description: 'Grunnflate kan også leses av kartet.',
            },
          },
          fields: {
            category: {
              label: 'Kategori',
              hint: 'Hentet fra Eiendomsregisteret når bygget finnes der.',
            },
            subcategory: {
              label: 'Underkategori',
              hint: 'Hentet fra Eiendomsregisteret når bygget finnes der.',
            },
            buildYear: {
              label: 'Byggeår',
              hint: 'Igangsettelsesåret, om det finnes.',
            },
            floors: {
              label: 'Antall etasjer',
              hint: 'Over bakkenivå. Kjeller legges til senere.',
            },
            footprint: {
              label: 'Grunnflate',
              hint: 'Fra Eiendomsregisteret eller kart.',
            },
            usableArea: {
              label: 'Totalt bruksareal (BRA)',
              hint: 'Samlet gulvareal for alle etasjer, målt innenfor ytterveggene.',
            },
            heatedArea: {
              label: 'Oppvarmet bruksareal',
              hint: 'Arealet som varmes opp til over 15 °C.',
            },
            floorHeight: {
              label: 'Gjennomsnittlig etasjehøyde',
              hint: 'La stå tom om du ikke vet, så brukes standardverdien for kategorien.',
            },
          },
          options: {
            categories: {
              kontor: 'Kontorbygning',
              lettIndustri: 'Lett industri',
              lager: 'Lagerbygning',
              forretning: 'Forretningsbygning',
              skole: 'Skolebygning',
              hotell: 'Hotellbygning',
            },
            subcategories: {
              lettindustriLager: 'Lettindustri og lager',
              verksted: 'Verksted',
              produksjon: 'Produksjonshall',
            },
          },
        },
        envelope: {
          nav: 'Klimaskall',
          title: 'Klimaskall',
          lead: 'Hvordan yttervegger er bygd avgjør hvor mye varme bygget mister. Velg det som ligner mest.',
          sections: {
            walls: {
              title: 'Yttervegger',
              description:
                'Materiale og tykkelse avgjør hvor mye varme veggene slipper ut.',
            },
            more: {
              title: 'Hva mer har bygget?',
              description: 'Det du huker av her åpner egne steg i menyen.',
            },
          },
          fields: {
            construction: {
              label: 'Konstruksjon',
              hint: 'Den vanligste typen om det er flere.',
            },
            insulation: {
              label: 'Isolasjonstykkelse',
              hint: 'La stå tom om du ikke vet — vi bruker byggeårets standard.',
            },
          },
          options: {
            walls: { tre: 'Tre', mur: 'Mur', staal: 'Stål', betong: 'Betong' },
            concrete: { betong10: '10 cm', betong20: '20 cm' },
          },
          checks: {
            basement: { label: 'Kjeller eller underetasje' },
            knowWindows: { label: 'Vinduer' },
            doors: { label: 'Dører' },
            gates: { label: 'Porter' },
          },
          aside: {
            title: 'Vegger og varmetap',
            body: 'Mye av varmen i et bygg forsvinner ut gjennom veggene. Materiale og isolasjon forteller rådgiveren hvor godt bygget holder på varmen. Velg det som ligner mest, så regner rådgiveren ut resten.',
          },
        },
        basement: {
          nav: 'Kjeller',
          title: 'Kjeller',
          knowMore: 'Vet du mer om kjelleren?',
          lead: 'Underetasjen regnes annerledes fordi den grenser mot grunnen og ikke mot uteluft.',
          aside: {
            title: 'Kjeller mot grunn',
            body: 'En kjeller grenser mot grunnen, ikke mot uteluft. Grunnen holder jevnere temperatur gjennom året, så varmetapet regnes annerledes enn for vegger over bakken. Om kjelleren er oppvarmet avgjør om den teller med i det oppvarmede arealet. Fyll inn det du vet, tomme felt får standardverdier.',
          },
          section: {
            title: 'Underetasjen',
            description: 'Bare det du vet. Tomme felt får standardverdier.',
          },
          checks: {
            heated: {
              label: 'Underetasjen er oppvarmet',
              description: 'Uoppvarmet kjeller regnes som buffer mot grunnen.',
            },
          },
          fields: {
            floorArea: { label: 'Gulvareal kjeller' },
            wallLength: { label: 'Lengde yttervegger' },
            floorHeight: { label: 'Etasjehøyde' },
            wallThickness: { label: 'Kjellerveggtykkelse' },
            depth: {
              label: 'Gjennomsnittlig høyde under bakkenivå',
              hint: 'Hvor dypt kjelleren ligger i terrenget.',
            },
          },
        },
        windows: {
          nav: 'Vinduer',
          title: 'Vinduer',
          knowMore: 'Vet du mer om fordelingen på fasadene?',
          lead: 'Vinduene står for mye av varmetapet — og solvarmen. Fordelingen på himmelretning betyr mest.',
          sections: { area: { title: 'Vinduene i bygget' } },
          checks: {
            even: {
              label: 'Alle vinduer er jevnt fordelt på bygget',
              description: 'Vi deler det totale arealet likt på fire fasader.',
            },
          },
          fields: {
            windowType: {
              label: 'Vindustype',
              hint: 'Den vanligste typen om det er flere.',
            },
            totalArea: {
              label: 'Totalt vindusareal',
              hint: 'Summen av alle vindusflater, målt utvendig på karmen.',
            },
            installYear: {
              label: 'Installasjonsår vinduer',
              hint: 'Året de nyeste vinduene ble satt inn.',
            },
            north: { label: 'Nord' },
            east: { label: 'Øst' },
            south: { label: 'Sør' },
            west: { label: 'Vest' },
          },
          aside: {
            title: 'Himmelretning',
            body: 'Vinduer mot sør slipper inn mest solvarme og reduserer oppvarmingsbehovet. Mot nord er det nesten bare varmetap. Derfor spør vi per fasade.',
          },
          areaSuggestions: {
            typical:
              'Typisk for {name}: {heated} av oppvarmet areal, {facade} av fasaden.',
            under: 'under {value} %',
            noArea:
              'Fyll inn oppvarmet areal under «Om bygget», så foreslår vi et vindusareal i m².',
            overTek17:
              'Det er {share} % av oppvarmet areal. TEK17 tillater maks {max} % i nye bygg, så sjekk tallet en gang til.',
            profiles: {
              office: {
                name: 'kontorbygg',
                note: 'Ofte store vindusbånd. Moderne bygg ligger gjerne opp mot 25 % av BRA.',
              },
              school: {
                name: 'skole- og universitetsbygg',
                note: 'Vinduene er samlet rundt klasserommene for å klare kravene til dagslys. Gymsaler og auditorier har lite vinduer.',
              },
              kindergarten: {
                name: 'barnehager',
                note: 'Mye dagslys i oppholdsrom, men ofte lave vindusrekker tilpasset barn.',
              },
              hotel: {
                name: 'hotellbygg',
                note: 'Fast mengde glass per hotellrom, lite glass i korridorer og bakarealer.',
              },
              shop: {
                name: 'forretningsbygg og butikker',
                note: 'Store utstillingsvinduer på gateplan, ellers tette fasader.',
              },
              shoppingCentre: {
                name: 'kjøpesentre',
                note: 'Svært lukkede bygg. Unntaket er inngangspartier og eventuelle glasstak.',
              },
              culture: {
                name: 'kulturbygg som kino og teater',
                note: 'Store glassflater i vestibyler og foajeer, men mørke og tette saler.',
              },
              sports: {
                name: 'idrettsbygg',
                note: 'Få vinduer i hallene for å unngå blending. Vinduene sitter mest i oppholdsrom og kontordeler.',
              },
              hospital: {
                name: 'sykehus og sykehjem',
                note: 'Jevnt fordelt på pasientrom. Sykehus har i tillegg store behandlingsfløyer uten vinduer.',
              },
              workshop: {
                name: 'verksted og lager',
                note: 'Svært få vinduer. Det er kjøreportene som utgjør mesteparten av åpningene i fasaden.',
              },
            },
          },
        },
        doors: {
          nav: 'Dører og porter',
          title: 'Dører og porter',
          knowMoreDoors: 'Vet du mer om dørene?',
          knowMoreGates: 'Vet du mer om portene?',
          lead: 'Dører og porter er en del av klimaskallet, og typen sier mye om varmetapet. Fyll inn det du vet eller husker, resten får standardverdier.',
          only: {
            doors: {
              nav: 'Dører',
              title: 'Dører',
              lead: 'Ytterdørene er en del av klimaskallet, og typen sier mye om varmetapet. Fyll inn det du vet eller husker, resten får standardverdier.',
              aside: {
                title: 'Dører og varmetap',
                body: 'En ytterdør slipper ut mer varme enn veggen rundt. Dørtypen forteller rådgiveren omtrent hvor godt den isolerer. Det du ikke vet, regner rådgiveren ut fra byggeåret og standardverdier.',
              },
            },
            gates: {
              nav: 'Porter',
              title: 'Porter',
              lead: 'Porter er ofte de største åpningene i klimaskallet, og typen sier mye om varmetapet. Fyll inn det du vet eller husker, resten får standardverdier.',
              aside: {
                title: 'Porter og varmetap',
                body: 'Porter er ofte de største åpningene i bygget, og de står gjerne åpne i perioder. Porttypen forteller rådgiveren omtrent hvor godt de isolerer. Det du ikke vet, regner rådgiveren ut fra byggeåret og standardverdier.',
              },
            },
          },
          aside: {
            title: 'Dører, porter og varmetap',
            body: 'Dører og porter slipper ut mer varme enn veggen rundt, og porter står gjerne åpne i perioder. Typen forteller rådgiveren omtrent hvor godt de isolerer. Det du ikke vet, regner rådgiveren ut fra byggeåret og standardverdier.',
          },
          sections: {
            doors: { title: 'Dører', description: 'Ytterdører for personer.' },
            gates: {
              title: 'Porter',
              description: 'Kjøreporter, lasteporter og lignende.',
            },
          },
          fields: {
            doorType: {
              label: 'Dørtype',
              hint: 'Den vanligste typen om det er flere.',
            },
            installYear: { label: 'Installasjonsår' },
            uValue: {
              label: 'U-verdi, gjennomsnitt',
              hint: 'La stå tom om du ikke vet.',
            },
            gateType: {
              label: 'Porttype',
              hint: 'Den vanligste typen om det er flere.',
            },
            area: { label: 'Areal' },
          },
          options: {
            doorTypes: {
              isolertStaal: 'Ståldør',
              glass: 'Glassdør',
              tre: 'Tredør',
              aluminium: 'Aluminiumsdør',
            },
            gateTypes: {
              leddportIsolert: 'Isolert leddport',
              leddport: 'Uisolert leddport',
              rulleport: 'Rulleport',
              hurtigport: 'Hurtigport',
            },
          },
        },
        energySources: {
          nav: 'Energikilder',
          title: 'Energikilder',
          lead: 'Hvilke energikilder har bygget? Valgene her åpner de neste stegene.',
          sections: {
            delivered: {
              title: 'Levert energi',
              description: 'Huk av alt som er koblet til bygget.',
            },
            own: { title: 'Egen produksjon' },
          },
          checks: {
            electricity: {
              label: 'Elektrisitet',
              description:
                'Alle bygg har strøm. Kun elektrisitet gir en forenklet beregning.',
            },
            districtHeating: {
              label: 'Fjernvarme',
              description: 'Åpner steget Sentralvarmeanlegg.',
            },
            heatPump: {
              label: 'Varmepumpe',
              description: 'Åpner steget Varmepumpe.',
            },
            fossil: {
              label: 'Olje, gass eller bio',
              description: 'Åpner steget Forbrenningskjel.',
            },
            other: {
              label: 'Andre energikilder',
              description: 'Beskriv i kommentarfeltet i siste steg.',
            },
            solar: {
              label: 'Bygget har solcelleanlegg',
              description: 'Åpner steget Solceller.',
            },
          },
          aside: {
            title: 'Sentralvarme',
            body: 'Fjernvarme, varmepumpe og kjeler kan alle være koblet til ett sentralvarmeanlegg. I neste steg spør vi hvordan de deler på oppvarming og varmtvann.',
          },
        },
        centralHeating: {
          nav: 'Sentralvarmeanlegg',
          title: 'Sentralvarmeanlegg',
          lead: 'Valgte energikilder — slik er de satt opp i sentralvarmeanlegget.',
          sections: {
            plant: { title: 'Anlegget' },
            districtHeating: {
              title: 'Fjernvarme',
              description: 'Slik brukes fjernvarmen i bygget.',
            },
          },
          fields: {
            location: { label: 'Lokasjon', hint: 'Hvor sentralen står.' },
            installYear: { label: 'Installasjonsår' },
            connectedTo: {
              label: 'Koblet til',
              hint: 'Hvor går vannet.',
            },
          },
          options: {
            locations: {
              tekniskRom: 'Teknisk rom',
              kjeller: 'Kjeller',
              tak: 'Tak',
              egetBygg: 'Eget bygg',
            },
            connections: {
              oppvarming: 'Oppvarming',
              oppvarmingVent: 'Oppvarming og ventilasjon',
            },
          },
          checks: {
            forHeating: { label: 'Romoppvarming' },
            forHotWater: { label: 'Tappevann' },
          },
          aside: {
            title: 'Varmen fordeles fra sentralen',
            body: 'Sentralvarmeanlegget sender varmen fra energikildene ut i bygget som vann. Hvor sentralen står, og om vannet også varmer ventilasjonsluften, avgjør hvor mye varme som går tapt på veien. Mangler du opplysningene, bruker vi standardverdier.',
          },
        },
        heatPump: {
          nav: 'Varmepumpe',
          title: 'Varmepumpe',
          knowMore: 'Vet du mer om varmepumpen?',
          lead: 'Type og ytelse på varmepumpen. Effekt og forbruk står vanligvis på typeskiltet eller i serviceheftet.',
          sections: {
            plant: { title: 'Anlegget' },
            connection: { title: 'Kobling' },
          },
          fields: {
            type: { label: 'Type' },
            installYear: { label: 'Installasjonsår' },
            power: {
              label: 'Effekt',
              hint: 'Nominell varmeeffekt fra typeskiltet.',
            },
            annualUse: {
              label: 'Årlig forbruk',
              hint: 'Fra strømmåler eller styringssystem, om det finnes.',
            },
          },
          options: {
            types: {
              luftLuft: 'Luft–luft',
              luftVann: 'Luft–vann',
              vaeskeVann: 'Væske–vann',
              avtrekk: 'Avtrekksvarmepumpe',
            },
          },
          checks: {
            connected: {
              label: 'Varmepumpen er koblet til sentralvarmeanlegget',
              description: 'Andelen settes i steget Oppvarming og kjøling.',
            },
          },
          aside: {
            title: 'Mer varme enn strøm',
            body: 'En varmepumpe henter varme fra luft, vann eller grunn og gir flere kilowattimer varme enn den bruker i strøm. Type, effekt og alder avgjør hvor effektiv den er, og det slår rett inn i energimerket. Mangler du tallene, bruker vi standardverdier.',
          },
        },
        boiler: {
          nav: 'Forbrenningskjel',
          title: 'Forbrenningskjel',
          lead: 'Kjelen som fyres med olje, gass eller biomasse. Effekten står vanligvis på typeskiltet.',
          sections: { plant: { title: 'Kjelen' } },
          fields: {
            fuelType: { label: 'Kjeltype' },
            power: {
              label: 'Effekt ved full last',
              hint: 'Fra typeskiltet eller dokumentasjonen.',
            },
          },
          options: {
            fuelTypes: { olje: 'Olje', gass: 'Gass', bio: 'Biomasse' },
          },
          aside: {
            title: 'Brenselet teller ulikt',
            body: 'Olje, gass og biomasse vektes ulikt i energiattesten, så kjeltypen påvirker både energimerket og oppvarmingskarakteren. Effekten forteller hvor stor del av varmebehovet kjelen kan dekke. Mangler du tallene, bruker vi standardverdier.',
          },
        },
        solar: {
          nav: 'Solceller',
          title: 'Solceller',
          knowMore: 'Vet du mer om solcelleanlegget?',
          lead: 'Egenprodusert strøm trekkes fra levert energi i attesten.',
          sections: {
            plant: {
              title: 'Solcelleanlegget',
              description:
                'Tallene står vanligvis i dokumentasjonen fra leverandøren eller i appen til anlegget.',
            },
            hotWater: { title: 'Varmtvann' },
          },
          fields: {
            installedPower: {
              label: 'Installert effekt',
              hint: 'Står i anleggsdokumentasjonen.',
            },
            installYear: { label: 'Installasjonsår' },
            annualProduction: {
              label: 'Årlig produksjon',
              hint: 'Fra inverteren eller appen til anlegget.',
            },
            panelArea: { label: 'Panelareal' },
          },
          checks: {
            hotWaterConnected: {
              label: 'Varmtvann er koblet til sentralanlegget',
              description:
                'Se energikilder. Ellers regnes varmtvann som elektrisk.',
            },
          },
          aside: {
            title: 'Egen strøm teller positivt',
            body: 'Strømmen fra solcellene dekker en del av det bygget bruker, og det kan gi et bedre energimerke. Derfor trenger vi å vite hvor stort anlegget er. Mangler du tallene, skriv det i kommentarfeltet i siste steg.',
          },
        },
        ventilation: {
          nav: 'Ventilasjon',
          systemTitle: 'Anlegg {number}',
          title: 'Ventilasjon',
          knowMore: 'Vet du mer om ventilasjonen?',
          lead: 'Har bygget ventilasjonsanlegg?',
          sections: {
            type: {
              title: 'Ventilasjonsanlegg',
              description:
                'Bare balansert ventilasjon trenger flere opplysninger.',
            },
            plant: {
              title: 'Anlegget',
              description:
                'Et aggregat blåser frisk luft inn og trekker brukt luft ut, ofte med varmegjenvinning.',
            },
            capacity: {
              title: 'Kapasitet — per anlegg',
              description:
                'Er kapasiteten større enn minsteverdien, må den oppgis.',
            },
            maintenance: { title: 'Vedlikehold' },
          },
          fields: {
            hasSystems: { label: 'Har bygget ventilasjonsanlegg?' },
            count: {
              label: 'Antall anlegg',
              hint: 'Du får ett sett med felter per anlegg.',
            },
            type: { label: 'Type' },
            installYear: { label: 'Installasjonsår' },
            heatRecovery: {
              label: 'Varmegjenvinningsgrad',
              hint: 'Fra dokumentasjonen på aggregatet.',
            },
            airflowOperating: { label: 'Luftmengde i driftstid' },
            airflowOff: { label: 'Luftmengde utenfor driftstid' },
            lastMaintenance: {
              label: 'Siste vedlikeholdsdato',
              hint: 'Fra servicerapporten.',
            },
            regularMaintenance: { label: 'Jevnlig vedlikehold av anlegget?' },
            moreInfo: {
              label: 'Har du mer informasjon til rådgiver om ventilasjonen?',
              hint: 'Filterbytte, driftstider, kjente avvik.',
            },
          },
          checks: {
            exhaustHeatPump: { label: 'Avkastvarmepumpe koblet til sentralen' },
            extractHeatPump: {
              label: 'Avtrekksvarmepumpe koblet til sentralen',
            },
          },
          options: {
            types: {
              avtrekk: 'Mekanisk avtrekk',
              balansert: 'Balansert ventilasjon',
            },
            typeDescriptions: {
              avtrekk: 'Store deler av bygget har et mekanisk avtrekk.',
            },
          },
          aside: {
            title: 'Luft og varme',
            body: 'Ventilasjonen bytter ut brukt inneluft med frisk uteluft. Et anlegg som gjenvinner varmen fra luften som går ut, sparer mye energi. Mangler du tallene, bruker vi standardverdier.',
          },
        },
        heating: {
          nav: 'Oppvarming og kjøling',
          title: 'Oppvarming og kjøling',
          lead: 'Forslagene under er basert på energikildene og ventilasjonen du valgte. Fyll inn andelen hver løsning dekker, om du vet den.',
          groups: {
            electric: { title: 'Elektrisk oppvarming' },
            central: { title: 'Sentralvarme' },
          },
          options: {
            electric: {
              panelHeaters: 'Panelovner',
              convectors: 'Konvektorer',
              electricBoiler: 'Elkjel med varmtvannstank',
              electricFloor: 'Gulvvarme',
              ventilationHeat: 'Ventilasjonsvarme',
              airToAir: 'Varmepumpe luft–luft',
            },
            central: {
              radiators: 'Radiatorer',
              convectors: 'Konvektorer',
              waterFloor: 'Gulvvarme',
              ventilationHeat: 'Ventilasjonsvarme',
            },
          },
          singleShare: 'Vi antar at denne dekker hele oppvarmingen.',
          sections: { cooling: { title: 'Kjøling' } },
          checks: {
            hasCooling: {
              label: 'Bygget har kjøling',
              description:
                'Kjølemaskin, fjernkjøling eller varmepumpe i kjølemodus.',
            },
          },
          aside: {
            title: 'Fyll inn det du vet',
            body: 'Hvis du ikke vet, trenger du ikke å fylle ut feltene. Fyll inn det du vet, vet noe om eller omtrentlige verdier. Mer detaljer gir energirådgiveren et bedre grunnlag.',
          },
        },
        summary: {
          nav: 'Oppsummering og innsending',
          title: 'Oppsummering og innsending',
          lead: 'Energiattesten blir mer nøyaktig — og ofte bedre — når flere felt er fylt ut.',
          alert: {
            title: '{count} steg bruker standardverdier',
            body: 'Mangelfullt datagrunnlag gjør at energimerkingen gjennomføres på begrenset informasjon. Deler av teknisk anlegg og bygg beregnes da etter standardverdier. Du kan sende inn nå eller gå tilbake å fylle inn et mer nøyaktig merke.',
          },
          registered: 'Det du har registrert',
          confirmFirst:
            'Bekreft at opplysningene er gitt i god tro før du sender inn.',
          sections: { advisor: { title: 'Til rådgiveren' } },
          fields: {
            note: {
              label: 'Er det noe rådgiveren bør vite om energiflyt og forbruk?',
              hint: 'For eksempel: deler av bygget står tomt, natt- og helgesenking, nylige utskiftinger, kjente lekkasjer.',
            },
          },
          checks: {
            goodFaith: {
              label:
                'All informasjon er registrert etter beste forståelse og i god tro',
              description:
                'Rådgiveren bruker svarene dine som grunnlag for energiattesten. Du kan rette opp senere om noe var feil.',
            },
          },
          aside: {
            eyebrow: 'Hva skjer nå?',
            title: 'Din registrering går til rådgiver',
            body: 'En energirådgiver går gjennom svarene dine og sender energiattesten til Enova. Ingen trenger å besøke bygget. Du får beskjed når attesten er klar.',
          },
        },
      },
    },
  },
};

export default NORWEGIAN;
